/*!
 * [Dojo](https://dojo.io/)
 * Copyright [JS Foundation](https://js.foundation/) & contributors
 * [New BSD license](https://github.com/dojo/meta/blob/master/LICENSE)
 * All rights reserved
 * 
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("src/main", [], factory);
	else if(typeof exports === 'object')
		exports["src/main"] = factory();
	else
		root["src/main"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 36);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
Object.defineProperty(exports, "__esModule", { value: true });
var globalObject = (function () {
    if (typeof global !== 'undefined') {
        // global spec defines a reference to the global object called 'global'
        // https://github.com/tc39/proposal-global
        // `global` is also defined in NodeJS
        return global;
    }
    else if (typeof window !== 'undefined') {
        // window is defined in browsers
        return window;
    }
    else if (typeof self !== 'undefined') {
        // self is defined in WebWorkers
        return self;
    }
})();
exports.default = globalObject;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var has_1 = __webpack_require__(9);
var global_1 = __webpack_require__(0);
exports.default = has_1.default;
__export(__webpack_require__(9));
/* ECMAScript 6 and 7 Features */
/* Array */
has_1.add('es6-array', function () {
    return [
        'from',
        'of'
    ].every(function (key) { return key in global_1.default.Array; }) && [
        'findIndex',
        'find',
        'copyWithin'
    ].every(function (key) { return key in global_1.default.Array.prototype; });
}, true);
has_1.add('es6-array-fill', function () {
    if ('fill' in global_1.default.Array.prototype) {
        /* Some versions of Safari do not properly implement this */
        return [1].fill(9, Number.POSITIVE_INFINITY)[0] === 1;
    }
    return false;
}, true);
has_1.add('es7-array', function () { return 'includes' in global_1.default.Array.prototype; }, true);
/* Map */
has_1.add('es6-map', function () {
    if (typeof global_1.default.Map === 'function') {
        /*
        IE11 and older versions of Safari are missing critical ES6 Map functionality
        We wrap this in a try/catch because sometimes the Map constructor exists, but does not
        take arguments (iOS 8.4)
         */
        try {
            var map = new global_1.default.Map([[0, 1]]);
            return map.has(0) &&
                typeof map.keys === 'function' && has_1.default('es6-symbol') &&
                typeof map.values === 'function' &&
                typeof map.entries === 'function';
        }
        catch (e) {
            /* istanbul ignore next: not testing on iOS at the moment */
            return false;
        }
    }
    return false;
}, true);
/* Math */
has_1.add('es6-math', function () {
    return [
        'clz32',
        'sign',
        'log10',
        'log2',
        'log1p',
        'expm1',
        'cosh',
        'sinh',
        'tanh',
        'acosh',
        'asinh',
        'atanh',
        'trunc',
        'fround',
        'cbrt',
        'hypot'
    ].every(function (name) { return typeof global_1.default.Math[name] === 'function'; });
}, true);
has_1.add('es6-math-imul', function () {
    if ('imul' in global_1.default.Math) {
        /* Some versions of Safari on ios do not properly implement this */
        return Math.imul(0xffffffff, 5) === -5;
    }
    return false;
}, true);
/* Object */
has_1.add('es6-object', function () {
    return has_1.default('es6-symbol') && [
        'assign',
        'is',
        'getOwnPropertySymbols',
        'setPrototypeOf'
    ].every(function (name) { return typeof global_1.default.Object[name] === 'function'; });
}, true);
has_1.add('es2017-object', function () {
    return [
        'values',
        'entries',
        'getOwnPropertyDescriptors'
    ].every(function (name) { return typeof global_1.default.Object[name] === 'function'; });
}, true);
/* Observable */
has_1.add('es-observable', function () { return typeof global_1.default.Observable !== 'undefined'; }, true);
/* Promise */
has_1.add('es6-promise', function () { return typeof global_1.default.Promise !== 'undefined' && has_1.default('es6-symbol'); }, true);
/* Set */
has_1.add('es6-set', function () {
    if (typeof global_1.default.Set === 'function') {
        /* IE11 and older versions of Safari are missing critical ES6 Set functionality */
        var set = new global_1.default.Set([1]);
        return set.has(1) && 'keys' in set && typeof set.keys === 'function' && has_1.default('es6-symbol');
    }
    return false;
}, true);
/* String */
has_1.add('es6-string', function () {
    return [
        'fromCodePoint'
    ].every(function (key) { return typeof global_1.default.String[key] === 'function'; }) && [
        'codePointAt',
        'normalize',
        'repeat',
        'startsWith',
        'endsWith',
        'includes'
    ].every(function (key) { return typeof global_1.default.String.prototype[key] === 'function'; });
}, true);
has_1.add('es6-string-raw', function () {
    function getCallSite(callSite) {
        var substitutions = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            substitutions[_i - 1] = arguments[_i];
        }
        return callSite;
    }
    if ('raw' in global_1.default.String) {
        var b = 1;
        var callSite = (_a = ["a\n", ""], _a.raw = ["a\\n", ""], getCallSite(_a, b));
        callSite.raw = ['a\\n'];
        var supportsTrunc = global_1.default.String.raw(callSite, 42) === 'a:\\n';
        return supportsTrunc;
    }
    return false;
    var _a;
}, true);
has_1.add('es2017-string', function () {
    return [
        'padStart',
        'padEnd'
    ].every(function (key) { return typeof global_1.default.String.prototype[key] === 'function'; });
}, true);
/* Symbol */
has_1.add('es6-symbol', function () { return typeof global_1.default.Symbol !== 'undefined' && typeof Symbol() === 'symbol'; }, true);
/* WeakMap */
has_1.add('es6-weakmap', function () {
    if (typeof global_1.default.WeakMap !== 'undefined') {
        /* IE11 and older versions of Safari are missing critical ES6 Map functionality */
        var key1 = {};
        var key2 = {};
        var map = new global_1.default.WeakMap([[key1, 1]]);
        Object.freeze(key1);
        return map.get(key1) === 1 && map.set(key2, 2) === map && has_1.default('es6-symbol');
    }
    return false;
}, true);
/* Miscellaneous features */
has_1.add('microtasks', function () { return has_1.default('es6-promise') || has_1.default('host-node') || has_1.default('dom-mutationobserver'); }, true);
has_1.add('postmessage', function () {
    // If window is undefined, and we have postMessage, it probably means we're in a web worker. Web workers have
    // post message but it doesn't work how we expect it to, so it's best just to pretend it doesn't exist.
    return typeof global_1.default.window !== 'undefined' && typeof global_1.default.postMessage === 'function';
}, true);
has_1.add('raf', function () { return typeof global_1.default.requestAnimationFrame === 'function'; }, true);
has_1.add('setimmediate', function () { return typeof global_1.default.setImmediate !== 'undefined'; }, true);
/* DOM Features */
has_1.add('dom-mutationobserver', function () {
    if (has_1.default('host-browser') && Boolean(global_1.default.MutationObserver || global_1.default.WebKitMutationObserver)) {
        // IE11 has an unreliable MutationObserver implementation where setProperty() does not
        // generate a mutation event, observers can crash, and the queue does not drain
        // reliably. The following feature test was adapted from
        // https://gist.github.com/t10ko/4aceb8c71681fdb275e33efe5e576b14
        var example = document.createElement('div');
        /* tslint:disable-next-line:variable-name */
        var HostMutationObserver = global_1.default.MutationObserver || global_1.default.WebKitMutationObserver;
        var observer = new HostMutationObserver(function () { });
        observer.observe(example, { attributes: true });
        example.style.setProperty('display', 'block');
        return Boolean(observer.takeRecords().length);
    }
    return false;
}, true);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var string_1 = __webpack_require__(28);
__webpack_require__(3);
var staticDone = { done: true, value: undefined };
/**
 * A class that _shims_ an iterator interface on array like objects.
 */
var ShimIterator = (function () {
    function ShimIterator(list) {
        this._nextIndex = -1;
        if (isIterable(list)) {
            this._nativeIterator = list[Symbol.iterator]();
        }
        else {
            this._list = list;
        }
    }
    ;
    /**
     * Return the next iteration result for the Iterator
     */
    ShimIterator.prototype.next = function () {
        if (this._nativeIterator) {
            return this._nativeIterator.next();
        }
        if (!this._list) {
            return staticDone;
        }
        if (++this._nextIndex < this._list.length) {
            return {
                done: false,
                value: this._list[this._nextIndex]
            };
        }
        return staticDone;
    };
    ;
    ShimIterator.prototype[Symbol.iterator] = function () {
        return this;
    };
    return ShimIterator;
}());
exports.ShimIterator = ShimIterator;
/**
 * A type guard for checking if something has an Iterable interface
 *
 * @param value The value to type guard against
 */
function isIterable(value) {
    return value && typeof value[Symbol.iterator] === 'function';
}
exports.isIterable = isIterable;
/**
 * A type guard for checking if something is ArrayLike
 *
 * @param value The value to type guard against
 */
function isArrayLike(value) {
    return value && typeof value.length === 'number';
}
exports.isArrayLike = isArrayLike;
/**
 * Returns the iterator for an object
 *
 * @param iterable The iterable object to return the iterator for
 */
function get(iterable) {
    if (isIterable(iterable)) {
        return iterable[Symbol.iterator]();
    }
    else if (isArrayLike(iterable)) {
        return new ShimIterator(iterable);
    }
}
exports.get = get;
/**
 * Shims the functionality of `for ... of` blocks
 *
 * @param iterable The object the provides an interator interface
 * @param callback The callback which will be called for each item of the iterable
 * @param thisArg Optional scope to pass the callback
 */
function forOf(iterable, callback, thisArg) {
    var broken = false;
    function doBreak() {
        broken = true;
    }
    /* We need to handle iteration of double byte strings properly */
    if (isArrayLike(iterable) && typeof iterable === 'string') {
        var l = iterable.length;
        for (var i = 0; i < l; ++i) {
            var char = iterable[i];
            if ((i + 1) < l) {
                var code = char.charCodeAt(0);
                if ((code >= string_1.HIGH_SURROGATE_MIN) && (code <= string_1.HIGH_SURROGATE_MAX)) {
                    char += iterable[++i];
                }
            }
            callback.call(thisArg, char, iterable, doBreak);
            if (broken) {
                return;
            }
        }
    }
    else {
        var iterator = get(iterable);
        if (iterator) {
            var result = iterator.next();
            while (!result.done) {
                callback.call(thisArg, result.value, iterable, doBreak);
                if (broken) {
                    return;
                }
                result = iterator.next();
            }
        }
    }
}
exports.forOf = forOf;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var has_1 = __webpack_require__(1);
var global_1 = __webpack_require__(0);
var util_1 = __webpack_require__(10);
exports.Symbol = global_1.default.Symbol;
if (!has_1.default('es6-symbol')) {
    /**
     * Throws if the value is not a symbol, used internally within the Shim
     * @param  {any}    value The value to check
     * @return {symbol}       Returns the symbol or throws
     */
    var validateSymbol_1 = function validateSymbol(value) {
        if (!isSymbol(value)) {
            throw new TypeError(value + ' is not a symbol');
        }
        return value;
    };
    var defineProperties_1 = Object.defineProperties;
    var defineProperty_1 = Object.defineProperty;
    var create_1 = Object.create;
    var objPrototype_1 = Object.prototype;
    var globalSymbols_1 = {};
    var getSymbolName_1 = (function () {
        var created = create_1(null);
        return function (desc) {
            var postfix = 0;
            var name;
            while (created[String(desc) + (postfix || '')]) {
                ++postfix;
            }
            desc += String(postfix || '');
            created[desc] = true;
            name = '@@' + desc;
            // FIXME: Temporary guard until the duplicate execution when testing can be
            // pinned down.
            if (!Object.getOwnPropertyDescriptor(objPrototype_1, name)) {
                defineProperty_1(objPrototype_1, name, {
                    set: function (value) {
                        defineProperty_1(this, name, util_1.getValueDescriptor(value));
                    }
                });
            }
            return name;
        };
    }());
    var InternalSymbol_1 = function Symbol(description) {
        if (this instanceof InternalSymbol_1) {
            throw new TypeError('TypeError: Symbol is not a constructor');
        }
        return Symbol(description);
    };
    exports.Symbol = global_1.default.Symbol = function Symbol(description) {
        if (this instanceof Symbol) {
            throw new TypeError('TypeError: Symbol is not a constructor');
        }
        var sym = Object.create(InternalSymbol_1.prototype);
        description = (description === undefined ? '' : String(description));
        return defineProperties_1(sym, {
            __description__: util_1.getValueDescriptor(description),
            __name__: util_1.getValueDescriptor(getSymbolName_1(description))
        });
    };
    /* Decorate the Symbol function with the appropriate properties */
    defineProperty_1(exports.Symbol, 'for', util_1.getValueDescriptor(function (key) {
        if (globalSymbols_1[key]) {
            return globalSymbols_1[key];
        }
        return (globalSymbols_1[key] = exports.Symbol(String(key)));
    }));
    defineProperties_1(exports.Symbol, {
        keyFor: util_1.getValueDescriptor(function (sym) {
            var key;
            validateSymbol_1(sym);
            for (key in globalSymbols_1) {
                if (globalSymbols_1[key] === sym) {
                    return key;
                }
            }
        }),
        hasInstance: util_1.getValueDescriptor(exports.Symbol.for('hasInstance'), false, false),
        isConcatSpreadable: util_1.getValueDescriptor(exports.Symbol.for('isConcatSpreadable'), false, false),
        iterator: util_1.getValueDescriptor(exports.Symbol.for('iterator'), false, false),
        match: util_1.getValueDescriptor(exports.Symbol.for('match'), false, false),
        observable: util_1.getValueDescriptor(exports.Symbol.for('observable'), false, false),
        replace: util_1.getValueDescriptor(exports.Symbol.for('replace'), false, false),
        search: util_1.getValueDescriptor(exports.Symbol.for('search'), false, false),
        species: util_1.getValueDescriptor(exports.Symbol.for('species'), false, false),
        split: util_1.getValueDescriptor(exports.Symbol.for('split'), false, false),
        toPrimitive: util_1.getValueDescriptor(exports.Symbol.for('toPrimitive'), false, false),
        toStringTag: util_1.getValueDescriptor(exports.Symbol.for('toStringTag'), false, false),
        unscopables: util_1.getValueDescriptor(exports.Symbol.for('unscopables'), false, false)
    });
    /* Decorate the InternalSymbol object */
    defineProperties_1(InternalSymbol_1.prototype, {
        constructor: util_1.getValueDescriptor(exports.Symbol),
        toString: util_1.getValueDescriptor(function () { return this.__name__; }, false, false)
    });
    /* Decorate the Symbol.prototype */
    defineProperties_1(exports.Symbol.prototype, {
        toString: util_1.getValueDescriptor(function () { return 'Symbol (' + validateSymbol_1(this).__description__ + ')'; }),
        valueOf: util_1.getValueDescriptor(function () { return validateSymbol_1(this); })
    });
    defineProperty_1(exports.Symbol.prototype, exports.Symbol.toPrimitive, util_1.getValueDescriptor(function () { return validateSymbol_1(this); }));
    defineProperty_1(exports.Symbol.prototype, exports.Symbol.toStringTag, util_1.getValueDescriptor('Symbol', false, false, true));
    defineProperty_1(InternalSymbol_1.prototype, exports.Symbol.toPrimitive, util_1.getValueDescriptor(exports.Symbol.prototype[exports.Symbol.toPrimitive], false, false, true));
    defineProperty_1(InternalSymbol_1.prototype, exports.Symbol.toStringTag, util_1.getValueDescriptor(exports.Symbol.prototype[exports.Symbol.toStringTag], false, false, true));
}
/**
 * A custom guard function that determines if an object is a symbol or not
 * @param  {any}       value The value to check to see if it is a symbol or not
 * @return {is symbol}       Returns true if a symbol or not (and narrows the type guard)
 */
function isSymbol(value) {
    return (value && ((typeof value === 'symbol') || (value['@@toStringTag'] === 'Symbol'))) || false;
}
exports.isSymbol = isSymbol;
/**
 * Fill any missing well known symbols if the native Symbol is missing them
 */
['hasInstance', 'isConcatSpreadable', 'iterator', 'species', 'replace', 'search', 'split', 'match', 'toPrimitive',
    'toStringTag', 'unscopables', 'observable'].forEach(function (wellKnown) {
    if (!exports.Symbol[wellKnown]) {
        Object.defineProperty(exports.Symbol, wellKnown, util_1.getValueDescriptor(exports.Symbol.for(wellKnown), false, false));
    }
});
exports.default = exports.Symbol;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = __webpack_require__(0);
var queue_1 = __webpack_require__(29);
var iterator_1 = __webpack_require__(2);
__webpack_require__(3);
var has_1 = __webpack_require__(1);
exports.ShimPromise = global_1.default.Promise;
exports.isThenable = function isThenable(value) {
    return value && typeof value.then === 'function';
};
if (!has_1.default('es6-promise')) {
    global_1.default.Promise = exports.ShimPromise = (_a = (function () {
            /**
             * Creates a new Promise.
             *
             * @constructor
             *
             * @param executor
             * The executor function is called immediately when the Promise is instantiated. It is responsible for
             * starting the asynchronous operation when it is invoked.
             *
             * The executor must call either the passed `resolve` function when the asynchronous operation has completed
             * successfully, or the `reject` function when the operation fails.
             */
            function Promise(executor) {
                var _this = this;
                /**
                 * The current state of this promise.
                 */
                this.state = 1 /* Pending */;
                this[Symbol.toStringTag] = 'Promise';
                /**
                 * If true, the resolution of this promise is chained ("locked in") to another promise.
                 */
                var isChained = false;
                /**
                 * Whether or not this promise is in a resolved state.
                 */
                var isResolved = function () {
                    return _this.state !== 1 /* Pending */ || isChained;
                };
                /**
                 * Callbacks that should be invoked once the asynchronous operation has completed.
                 */
                var callbacks = [];
                /**
                 * Initially pushes callbacks onto a queue for execution once this promise settles. After the promise settles,
                 * enqueues callbacks for execution on the next event loop turn.
                 */
                var whenFinished = function (callback) {
                    if (callbacks) {
                        callbacks.push(callback);
                    }
                };
                /**
                 * Settles this promise.
                 *
                 * @param newState The resolved state for this promise.
                 * @param {T|any} value The resolved value for this promise.
                 */
                var settle = function (newState, value) {
                    // A promise can only be settled once.
                    if (_this.state !== 1 /* Pending */) {
                        return;
                    }
                    _this.state = newState;
                    _this.resolvedValue = value;
                    whenFinished = queue_1.queueMicroTask;
                    // Only enqueue a callback runner if there are callbacks so that initially fulfilled Promises don't have to
                    // wait an extra turn.
                    if (callbacks && callbacks.length > 0) {
                        queue_1.queueMicroTask(function () {
                            if (callbacks) {
                                var count = callbacks.length;
                                for (var i = 0; i < count; ++i) {
                                    callbacks[i].call(null);
                                }
                                callbacks = null;
                            }
                        });
                    }
                };
                /**
                 * Resolves this promise.
                 *
                 * @param newState The resolved state for this promise.
                 * @param {T|any} value The resolved value for this promise.
                 */
                var resolve = function (newState, value) {
                    if (isResolved()) {
                        return;
                    }
                    if (exports.isThenable(value)) {
                        value.then(settle.bind(null, 0 /* Fulfilled */), settle.bind(null, 2 /* Rejected */));
                        isChained = true;
                    }
                    else {
                        settle(newState, value);
                    }
                };
                this.then = function (onFulfilled, onRejected) {
                    return new Promise(function (resolve, reject) {
                        // whenFinished initially queues up callbacks for execution after the promise has settled. Once the
                        // promise has settled, whenFinished will schedule callbacks for execution on the next turn through the
                        // event loop.
                        whenFinished(function () {
                            var callback = _this.state === 2 /* Rejected */ ? onRejected : onFulfilled;
                            if (typeof callback === 'function') {
                                try {
                                    resolve(callback(_this.resolvedValue));
                                }
                                catch (error) {
                                    reject(error);
                                }
                            }
                            else if (_this.state === 2 /* Rejected */) {
                                reject(_this.resolvedValue);
                            }
                            else {
                                resolve(_this.resolvedValue);
                            }
                        });
                    });
                };
                try {
                    executor(resolve.bind(null, 0 /* Fulfilled */), resolve.bind(null, 2 /* Rejected */));
                }
                catch (error) {
                    settle(2 /* Rejected */, error);
                }
            }
            Promise.all = function (iterable) {
                return new this(function (resolve, reject) {
                    var values = [];
                    var complete = 0;
                    var total = 0;
                    var populating = true;
                    function fulfill(index, value) {
                        values[index] = value;
                        ++complete;
                        finish();
                    }
                    function finish() {
                        if (populating || complete < total) {
                            return;
                        }
                        resolve(values);
                    }
                    function processItem(index, item) {
                        ++total;
                        if (exports.isThenable(item)) {
                            // If an item Promise rejects, this Promise is immediately rejected with the item
                            // Promise's rejection error.
                            item.then(fulfill.bind(null, index), reject);
                        }
                        else {
                            Promise.resolve(item).then(fulfill.bind(null, index));
                        }
                    }
                    var i = 0;
                    iterator_1.forOf(iterable, function (value) {
                        processItem(i, value);
                        i++;
                    });
                    populating = false;
                    finish();
                });
            };
            Promise.race = function (iterable) {
                return new this(function (resolve, reject) {
                    iterator_1.forOf(iterable, function (item) {
                        if (item instanceof Promise) {
                            // If a Promise item rejects, this Promise is immediately rejected with the item
                            // Promise's rejection error.
                            item.then(resolve, reject);
                        }
                        else {
                            Promise.resolve(item).then(resolve);
                        }
                    });
                });
            };
            Promise.reject = function (reason) {
                return new this(function (resolve, reject) {
                    reject(reason);
                });
            };
            Promise.resolve = function (value) {
                return new this(function (resolve) {
                    resolve(value);
                });
            };
            Promise.prototype.catch = function (onRejected) {
                return this.then(undefined, onRejected);
            };
            return Promise;
        }()),
        _a[Symbol.species] = exports.ShimPromise,
        _a);
}
exports.default = exports.ShimPromise;
var _a;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = __webpack_require__(0);
var has_1 = __webpack_require__(1);
var Symbol_1 = __webpack_require__(3);
if (has_1.default('es6-object')) {
    var globalObject = global_1.default.Object;
    exports.assign = globalObject.assign;
    exports.getOwnPropertyDescriptor = globalObject.getOwnPropertyDescriptor;
    exports.getOwnPropertyNames = globalObject.getOwnPropertyNames;
    exports.getOwnPropertySymbols = globalObject.getOwnPropertySymbols;
    exports.is = globalObject.is;
    exports.keys = globalObject.keys;
}
else {
    exports.keys = function symbolAwareKeys(o) {
        return Object.keys(o).filter(function (key) { return !Boolean(key.match(/^@@.+/)); });
    };
    exports.assign = function assign(target) {
        var sources = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            sources[_i - 1] = arguments[_i];
        }
        if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }
        var to = Object(target);
        sources.forEach(function (nextSource) {
            if (nextSource) {
                exports.keys(nextSource).forEach(function (nextKey) {
                    to[nextKey] = nextSource[nextKey];
                });
            }
        });
        return to;
    };
    exports.getOwnPropertyDescriptor = function getOwnPropertyDescriptor(o, prop) {
        if (Symbol_1.isSymbol(prop)) {
            return Object.getOwnPropertyDescriptor(o, prop);
        }
        else {
            return Object.getOwnPropertyDescriptor(o, prop);
        }
    };
    exports.getOwnPropertyNames = function getOwnPropertyNames(o) {
        return Object.getOwnPropertyNames(o).filter(function (key) { return !Boolean(key.match(/^@@.+/)); });
    };
    exports.getOwnPropertySymbols = function getOwnPropertySymbols(o) {
        return Object.getOwnPropertyNames(o).filter(function (key) { return Boolean(key.match(/^@@.+/)); })
            .map(function (key) { return Symbol.for(key.substring(2)); });
    };
    exports.is = function is(value1, value2) {
        if (value1 === value2) {
            return value1 !== 0 || 1 / value1 === 1 / value2; // -0
        }
        return value1 !== value1 && value2 !== value2; // NaN
    };
}
if (has_1.default('es2017-object')) {
    var globalObject = global_1.default.Object;
    exports.getOwnPropertyDescriptors = globalObject.getOwnPropertyDescriptors;
    exports.entries = globalObject.entries;
    exports.values = globalObject.values;
}
else {
    exports.getOwnPropertyDescriptors = function getOwnPropertyDescriptors(o) {
        return exports.getOwnPropertyNames(o).reduce(function (previous, key) {
            previous[key] = exports.getOwnPropertyDescriptor(o, key);
            return previous;
        }, {});
    };
    exports.entries = function entries(o) {
        return exports.keys(o).map(function (key) { return [key, o[key]]; });
    };
    exports.values = function values(o) {
        return exports.keys(o).map(function (key) { return o[key]; });
    };
}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExtensiblePromise_1 = __webpack_require__(16);
/**
 * A type guard that determines if `value` is a `Task`
 * @param value The value to guard
 */
function isTask(value) {
    return Boolean(value && typeof value.cancel === 'function' && Array.isArray(value.children) && isThenable(value));
}
exports.isTask = isTask;
/**
 * Returns true if a given value has a `then` method.
 * @param {any} value The value to check if is Thenable
 * @returns {is Thenable<T>} A type guard if the value is thenable
 */
function isThenable(value) {
    return value && typeof value.then === 'function';
}
exports.isThenable = isThenable;
/**
 * Task is an extension of Promise that supports cancellation and the Task#finally method.
 */
var Task = (function (_super) {
    __extends(Task, _super);
    /**
     * @constructor
     *
     * Create a new task. Executor is run immediately. The canceler will be called when the task is canceled.
     *
     * @param executor Method that initiates some task
     * @param canceler Method to call when the task is canceled
     *
     */
    function Task(executor, canceler) {
        var _this = this;
        // we have to initialize these to avoid a compiler error of using them before they are initialized
        var superResolve = function () { };
        var superReject = function () { };
        _this = _super.call(this, function (resolve, reject) {
            superResolve = resolve;
            superReject = reject;
        }) || this;
        _this._state = 1 /* Pending */;
        _this.children = [];
        _this.canceler = function () {
            if (canceler) {
                canceler();
            }
            _this._cancel();
        };
        // Don't let the Task resolve if it's been canceled
        try {
            executor(function (value) {
                if (_this._state === 3 /* Canceled */) {
                    return;
                }
                _this._state = 0 /* Fulfilled */;
                superResolve(value);
            }, function (reason) {
                if (_this._state === 3 /* Canceled */) {
                    return;
                }
                _this._state = 2 /* Rejected */;
                superReject(reason);
            });
        }
        catch (reason) {
            _this._state = 2 /* Rejected */;
            superReject(reason);
        }
        return _this;
    }
    /**
     * Return a Task that resolves when one of the passed in objects have resolved
     *
     * @param iterable    An iterable of values to resolve. These can be Promises, ExtensiblePromises, or other objects
     * @returns {Task}
     */
    Task.race = function (iterable) {
        return new this(function (resolve, reject) {
            Promise.race(ExtensiblePromise_1.unwrapPromises(iterable)).then(resolve, reject);
        });
    };
    /**
     * Return a rejected promise wrapped in a Task
     *
     * @param reason The reason for the rejection
     * @returns A task
     */
    Task.reject = function (reason) {
        return new this(function (resolve, reject) { return reject(reason); });
    };
    /**
     * Return a resolved task.
     *
     * @param value The value to resolve with
     *
     * @return A task
     */
    Task.resolve = function (value) {
        return new this(function (resolve, reject) { return resolve(value); });
    };
    /**
     * Return a ExtensiblePromise that resolves when all of the passed in objects have resolved. When used with a key/value
     * pair, the returned promise's argument is a key/value pair of the original keys with their resolved values.
     *
     * @example
     * ExtensiblePromise.all({ one: 1, two: 2 }).then(results => console.log(results));
     * // { one: 1, two: 2 }
     *
     * @param iterable    An iterable of values to resolve, or a key/value pair of values to resolve. These can be Promises, ExtensiblePromises, or other objects
     * @returns An extensible promise
     */
    Task.all = function (iterable) {
        return _super.all.call(this, iterable);
    };
    Object.defineProperty(Task.prototype, "state", {
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Propagates cancellation down through a Task tree. The Task's state is immediately set to canceled. If a Thenable
     * finally task was passed in, it is resolved before calling this Task's finally callback; otherwise, this Task's
     * finally callback is immediately executed. `_cancel` is called for each child Task, passing in the value returned
     * by this Task's finally callback or a Promise chain that will eventually resolve to that value.
     */
    Task.prototype._cancel = function (finallyTask) {
        var _this = this;
        this._state = 3 /* Canceled */;
        var runFinally = function () {
            try {
                return _this._finally();
            }
            catch (error) {
                // Any errors in a `finally` callback are completely ignored during cancelation
            }
        };
        if (this._finally) {
            if (isThenable(finallyTask)) {
                finallyTask = finallyTask.then(runFinally, runFinally);
            }
            else {
                finallyTask = runFinally();
            }
        }
        this.children.forEach(function (child) {
            child._cancel(finallyTask);
        });
    };
    /**
     * Immediately cancels this task if it has not already resolved. This Task and any descendants are synchronously set
     * to the Canceled state and any `finally` added downstream from the canceled Task are invoked.
     */
    Task.prototype.cancel = function () {
        if (this._state === 1 /* Pending */) {
            this.canceler();
        }
    };
    Task.prototype.catch = function (onRejected) {
        return this.then(undefined, onRejected);
    };
    /**
     * Allows for cleanup actions to be performed after resolution of a Promise.
     */
    Task.prototype.finally = function (callback) {
        // if this task is already canceled, call the task
        if (this._state === 3 /* Canceled */) {
            callback();
            return this;
        }
        var task = this.then(function (value) { return Task.resolve(callback()).then(function () { return value; }); }, function (reason) { return Task.resolve(callback()).then(function () {
            throw reason;
        }); });
        // Keep a reference to the callback; it will be called if the Task is canceled
        task._finally = callback;
        return task;
    };
    /**
     * Adds a callback to be invoked when the Task resolves or is rejected.
     *
     * @param onFulfilled   A function to call to handle the resolution. The paramter to the function will be the resolved value, if any.
     * @param onRejected    A function to call to handle the error. The parameter to the function will be the caught error.
     *
     * @returns A task
     */
    Task.prototype.then = function (onFulfilled, onRejected) {
        var _this = this;
        // FIXME
        // tslint:disable-next-line:no-var-keyword
        var task = _super.prototype.then.call(this, 
        // Don't call the onFulfilled or onRejected handlers if this Task is canceled
        function (value) {
            if (task._state === 3 /* Canceled */) {
                return;
            }
            if (onFulfilled) {
                return onFulfilled(value);
            }
            return value;
        }, function (error) {
            if (task._state === 3 /* Canceled */) {
                return;
            }
            if (onRejected) {
                return onRejected(error);
            }
            throw error;
        });
        task.canceler = function () {
            // If task's parent (this) hasn't been resolved, cancel it; downward propagation will start at the first
            // unresolved parent
            if (_this._state === 1 /* Pending */) {
                _this.cancel();
            }
            else {
                task._cancel();
            }
        };
        // Keep track of child Tasks for propogating cancelation back down the chain
        this.children.push(task);
        return task;
    };
    return Task;
}(ExtensiblePromise_1.default));
exports.default = Task;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = __webpack_require__(5);
var object_2 = __webpack_require__(5);
exports.assign = object_2.assign;
var slice = Array.prototype.slice;
var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Type guard that ensures that the value can be coerced to Object
 * to weed out host objects that do not derive from Object.
 * This function is used to check if we want to deep copy an object or not.
 * Note: In ES6 it is possible to modify an object's Symbol.toStringTag property, which will
 * change the value returned by `toString`. This is a rare edge case that is difficult to handle,
 * so it is not handled here.
 * @param  value The value to check
 * @return       If the value is coercible into an Object
 */
function shouldDeepCopyObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}
function copyArray(array, inherited) {
    return array.map(function (item) {
        if (Array.isArray(item)) {
            return copyArray(item, inherited);
        }
        return !shouldDeepCopyObject(item) ?
            item :
            _mixin({
                deep: true,
                inherited: inherited,
                sources: [item],
                target: {}
            });
    });
}
function _mixin(kwArgs) {
    var deep = kwArgs.deep;
    var inherited = kwArgs.inherited;
    var target = kwArgs.target;
    var copied = kwArgs.copied || [];
    var copiedClone = copied.slice();
    for (var _i = 0, _a = kwArgs.sources; _i < _a.length; _i++) {
        var source = _a[_i];
        if (source === null || source === undefined) {
            continue;
        }
        for (var key in source) {
            if (inherited || hasOwnProperty.call(source, key)) {
                var value = source[key];
                if (copiedClone.indexOf(value) !== -1) {
                    continue;
                }
                if (deep) {
                    if (Array.isArray(value)) {
                        value = copyArray(value, inherited);
                    }
                    else if (shouldDeepCopyObject(value)) {
                        var targetValue = target[key] || {};
                        copied.push(source);
                        value = _mixin({
                            deep: true,
                            inherited: inherited,
                            sources: [value],
                            target: targetValue,
                            copied: copied
                        });
                    }
                }
                target[key] = value;
            }
        }
    }
    return target;
}
function create(prototype) {
    var mixins = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        mixins[_i - 1] = arguments[_i];
    }
    if (!mixins.length) {
        throw new RangeError('lang.create requires at least one mixin object.');
    }
    var args = mixins.slice();
    args.unshift(Object.create(prototype));
    return object_1.assign.apply(null, args);
}
exports.create = create;
function deepAssign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    return _mixin({
        deep: true,
        inherited: false,
        sources: sources,
        target: target
    });
}
exports.deepAssign = deepAssign;
function deepMixin(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    return _mixin({
        deep: true,
        inherited: true,
        sources: sources,
        target: target
    });
}
exports.deepMixin = deepMixin;
/**
 * Creates a new object using the provided source's prototype as the prototype for the new object, and then
 * deep copies the provided source's values into the new target.
 *
 * @param source The object to duplicate
 * @return The new object
 */
function duplicate(source) {
    var target = Object.create(Object.getPrototypeOf(source));
    return deepMixin(target, source);
}
exports.duplicate = duplicate;
/**
 * Determines whether two values are the same value.
 *
 * @param a First value to compare
 * @param b Second value to compare
 * @return true if the values are the same; false otherwise
 */
function isIdentical(a, b) {
    return a === b ||
        /* both values are NaN */
        (a !== a && b !== b);
}
exports.isIdentical = isIdentical;
/**
 * Returns a function that binds a method to the specified object at runtime. This is similar to
 * `Function.prototype.bind`, but instead of a function it takes the name of a method on an object.
 * As a result, the function returned by `lateBind` will always call the function currently assigned to
 * the specified property on the object as of the moment the function it returns is called.
 *
 * @param instance The context object
 * @param method The name of the method on the context object to bind to itself
 * @param suppliedArgs An optional array of values to prepend to the `instance[method]` arguments list
 * @return The bound function
 */
function lateBind(instance, method) {
    var suppliedArgs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        suppliedArgs[_i - 2] = arguments[_i];
    }
    return suppliedArgs.length ?
        function () {
            var args = arguments.length ? suppliedArgs.concat(slice.call(arguments)) : suppliedArgs;
            // TS7017
            return instance[method].apply(instance, args);
        } :
        function () {
            // TS7017
            return instance[method].apply(instance, arguments);
        };
}
exports.lateBind = lateBind;
function mixin(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    return _mixin({
        deep: false,
        inherited: true,
        sources: sources,
        target: target
    });
}
exports.mixin = mixin;
/**
 * Returns a function which invokes the given function with the given arguments prepended to its argument list.
 * Like `Function.prototype.bind`, but does not alter execution context.
 *
 * @param targetFunction The function that needs to be bound
 * @param suppliedArgs An optional array of arguments to prepend to the `targetFunction` arguments list
 * @return The bound function
 */
function partial(targetFunction) {
    var suppliedArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        suppliedArgs[_i - 1] = arguments[_i];
    }
    return function () {
        var args = arguments.length ? suppliedArgs.concat(slice.call(arguments)) : suppliedArgs;
        return targetFunction.apply(this, args);
    };
}
exports.partial = partial;
/**
 * Returns an object with a destroy method that, when called, calls the passed-in destructor.
 * This is intended to provide a unified interface for creating "remove" / "destroy" handlers for
 * event listeners, timers, etc.
 *
 * @param destructor A function that will be called when the handle's `destroy` method is invoked
 * @return The handle object
 */
function createHandle(destructor) {
    return {
        destroy: function () {
            this.destroy = function () { };
            destructor.call(this);
        }
    };
}
exports.createHandle = createHandle;
/**
 * Returns a single handle that can be used to destroy multiple handles simultaneously.
 *
 * @param handles An array of handles with `destroy` methods
 * @return The handle object
 */
function createCompositeHandle() {
    var handles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        handles[_i] = arguments[_i];
    }
    return createHandle(function () {
        for (var _i = 0, handles_1 = handles; _i < handles_1.length; _i++) {
            var handle = handles_1[_i];
            handle.destroy();
        }
    });
}
exports.createCompositeHandle = createCompositeHandle;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {
Object.defineProperty(exports, "__esModule", { value: true });
function isFeatureTestThenable(value) {
    return value && value.then;
}
/**
 * A cache of results of feature tests
 */
exports.testCache = {};
/**
 * A cache of the un-resolved feature tests
 */
exports.testFunctions = {};
/**
 * A cache of unresolved thenables (probably promises)
 * @type {{}}
 */
var testThenables = {};
/**
 * A reference to the global scope (`window` in a browser, `global` in NodeJS)
 */
var globalScope = (function () {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
        // Browsers
        return window;
    }
    else if (typeof global !== 'undefined') {
        // Node
        return global;
    }
    else if (typeof self !== 'undefined') {
        // Web workers
        return self;
    }
    /* istanbul ignore next */
    return {};
})();
/* Grab the staticFeatures if there are available */
var staticFeatures = (globalScope.DojoHasEnvironment || {}).staticFeatures;
/* Cleaning up the DojoHasEnviornment */
if ('DojoHasEnvironment' in globalScope) {
    delete globalScope.DojoHasEnvironment;
}
/**
 * Custom type guard to narrow the `staticFeatures` to either a map or a function that
 * returns a map.
 *
 * @param value The value to guard for
 */
function isStaticFeatureFunction(value) {
    return typeof value === 'function';
}
/**
 * The cache of asserted features that were available in the global scope when the
 * module loaded
 */
var staticCache = staticFeatures
    ? isStaticFeatureFunction(staticFeatures)
        ? staticFeatures.apply(globalScope)
        : staticFeatures
    : {};/* Providing an empty cache, if none was in the environment

/**
* AMD plugin function.
*
* Conditional loads modules based on a has feature test value.
*
* @param resourceId Gives the resolved module id to load.
* @param require The loader require function with respect to the module that contained the plugin resource in its
*                dependency list.
* @param load Callback to loader that consumes result of plugin demand.
*/
function load(resourceId, require, load, config) {
    resourceId ? require([resourceId], load) : load();
}
exports.load = load;
/**
 * AMD plugin function.
 *
 * Resolves resourceId into a module id based on possibly-nested tenary expression that branches on has feature test
 * value(s).
 *
 * @param resourceId The id of the module
 * @param normalize Resolves a relative module id into an absolute module id
 */
function normalize(resourceId, normalize) {
    var tokens = resourceId.match(/[\?:]|[^:\?]*/g) || [];
    var i = 0;
    function get(skip) {
        var term = tokens[i++];
        if (term === ':') {
            // empty string module name, resolves to null
            return null;
        }
        else {
            // postfixed with a ? means it is a feature to branch on, the term is the name of the feature
            if (tokens[i++] === '?') {
                if (!skip && has(term)) {
                    // matched the feature, get the first value from the options
                    return get();
                }
                else {
                    // did not match, get the second value, passing over the first
                    get(true);
                    return get(skip);
                }
            }
            // a module
            return term;
        }
    }
    var id = get();
    return id && normalize(id);
}
exports.normalize = normalize;
/**
 * Check if a feature has already been registered
 *
 * @param feature the name of the feature
 */
function exists(feature) {
    var normalizedFeature = feature.toLowerCase();
    return Boolean(normalizedFeature in staticCache || normalizedFeature in exports.testCache || exports.testFunctions[normalizedFeature]);
}
exports.exists = exists;
/**
 * Register a new test for a named feature.
 *
 * @example
 * has.add('dom-addeventlistener', !!document.addEventListener);
 *
 * @example
 * has.add('touch-events', function () {
 *    return 'ontouchstart' in document
 * });
 *
 * @param feature the name of the feature
 * @param value the value reported of the feature, or a function that will be executed once on first test
 * @param overwrite if an existing value should be overwritten. Defaults to false.
 */
function add(feature, value, overwrite) {
    if (overwrite === void 0) { overwrite = false; }
    var normalizedFeature = feature.toLowerCase();
    if (exists(normalizedFeature) && !overwrite && !(normalizedFeature in staticCache)) {
        throw new TypeError("Feature \"" + feature + "\" exists and overwrite not true.");
    }
    if (typeof value === 'function') {
        exports.testFunctions[normalizedFeature] = value;
    }
    else if (isFeatureTestThenable(value)) {
        testThenables[feature] = value.then(function (resolvedValue) {
            exports.testCache[feature] = resolvedValue;
            delete testThenables[feature];
        }, function () {
            delete testThenables[feature];
        });
    }
    else {
        exports.testCache[normalizedFeature] = value;
        delete exports.testFunctions[normalizedFeature];
    }
}
exports.add = add;
/**
 * Return the current value of a named feature.
 *
 * @param feature The name (if a string) or identifier (if an integer) of the feature to test.
 */
function has(feature) {
    var result;
    var normalizedFeature = feature.toLowerCase();
    if (normalizedFeature in staticCache) {
        result = staticCache[normalizedFeature];
    }
    else if (exports.testFunctions[normalizedFeature]) {
        result = exports.testCache[normalizedFeature] = exports.testFunctions[normalizedFeature].call(null);
        delete exports.testFunctions[normalizedFeature];
    }
    else if (normalizedFeature in exports.testCache) {
        result = exports.testCache[normalizedFeature];
    }
    else if (feature in testThenables) {
        return false;
    }
    else {
        throw new TypeError("Attempt to detect unregistered has feature \"" + feature + "\"");
    }
    return result;
}
exports.default = has;
/*
 * Out of the box feature tests
 */
/* Environments */
/* Used as a value to provide a debug only code path */
add('debug', true);
/* Detects if the environment is "browser like" */
add('host-browser', typeof document !== 'undefined' && typeof location !== 'undefined');
/* Detects if the environment appears to be NodeJS */
add('host-node', function () {
    if (typeof process === 'object' && process.versions && process.versions.node) {
        return process.versions.node;
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(11)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Helper function to generate a value property descriptor
 *
 * @param value        The value the property descriptor should be set to
 * @param enumerable   If the property should be enumberable, defaults to false
 * @param writable     If the property should be writable, defaults to true
 * @param configurable If the property should be configurable, defaults to true
 * @return             The property descriptor object
 */
function getValueDescriptor(value, enumerable, writable, configurable) {
    if (enumerable === void 0) { enumerable = false; }
    if (writable === void 0) { writable = true; }
    if (configurable === void 0) { configurable = true; }
    return {
        value: value,
        enumerable: enumerable,
        writable: writable,
        configurable: configurable
    };
}
exports.getValueDescriptor = getValueDescriptor;
/**
 * A helper function which wraps a function where the first argument becomes the scope
 * of the call
 *
 * @param nativeFunction The source function to be wrapped
 */
function wrapNative(nativeFunction) {
    return function (target) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return nativeFunction.apply(target, args);
    };
}
exports.wrapNative = wrapNative;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var model_1 = __webpack_require__(34);
var quantizer_1 = __webpack_require__(32);
var ungeneralize = model_1.query();
var items = document.querySelectorAll(".quantizer");
var _loop_1 = function (i) {
    var item = items[i];
    var isClientSide = item.getAttribute("data-mode") === "client";
    var scale = parseInt(item.getAttribute("data-scale"));
    var removeCollinearVertices = item.getAttribute("data-remove-collinear-vertices") === "true";
    var q = quantizer_1.quantizer(item);
    var promise = (isClientSide || scale == null) ? ungeneralize : model_1.query(scale);
    promise.then(function (model) {
        q.setProperties(__assign({}, model, { scale: scale,
            removeCollinearVertices: removeCollinearVertices,
            isClientSide: isClientSide }));
    })
        .catch(function (error) {
        console.error(error);
    });
};
for (var i = 0; i < items.length; i++) {
    _loop_1(i);
}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = __webpack_require__(26);
var Promise_1 = __webpack_require__(4);
function isSubscribable(object) {
    return object && object.subscribe !== undefined;
}
var Observable = (function (_super) {
    __extends(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.of = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        return _super.of.apply(this, items);
    };
    Observable.from = function (item) {
        return _super.from.call(this, item);
    };
    Observable.defer = function (deferFunction) {
        return new Observable(function (observer) {
            var trueObservable = deferFunction();
            return trueObservable.subscribe({
                next: function (value) {
                    return observer.next(value);
                },
                error: function (errorValue) {
                    return observer.error(errorValue);
                },
                complete: function (completeValue) {
                    observer.complete(completeValue);
                }
            });
        });
    };
    Observable.prototype.toPromise = function () {
        var _this = this;
        return new Promise_1.default(function (resolve, reject) {
            _this.subscribe({
                next: function (value) {
                    resolve(value);
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    };
    Observable.prototype.map = function (mapFunction) {
        var self = this;
        if (typeof mapFunction !== 'function') {
            throw new TypeError('Map parameter must be a function');
        }
        return new Observable(function (observer) {
            self.subscribe({
                next: function (value) {
                    try {
                        var result = mapFunction(value);
                        return observer.next(result);
                    }
                    catch (e) {
                        return observer.error(e);
                    }
                },
                error: function (errorValue) {
                    return observer.error(errorValue);
                },
                complete: function (completeValue) {
                    return observer.complete(completeValue);
                }
            });
        });
    };
    Observable.prototype.filter = function (filterFunction) {
        var self = this;
        if (typeof filterFunction !== 'function') {
            throw new TypeError('Filter argument must be a function');
        }
        return new Observable(function (observer) {
            self.subscribe({
                next: function (value) {
                    try {
                        if (filterFunction(value)) {
                            return observer.next(value);
                        }
                    }
                    catch (e) {
                        return observer.error(e);
                    }
                },
                error: function (errorValue) {
                    return observer.error(errorValue);
                },
                complete: function (completeValue) {
                    return observer.complete(completeValue);
                }
            });
        });
    };
    Observable.prototype.toArray = function () {
        var self = this;
        return new Observable(function (observer) {
            var values = [];
            self.subscribe({
                next: function (value) {
                    values.push(value);
                },
                error: function (errorValue) {
                    return observer.error(errorValue);
                },
                complete: function (completeValue) {
                    observer.next(values);
                    observer.complete(completeValue);
                }
            });
        });
    };
    Observable.prototype.mergeAll = function (concurrent) {
        var self = this;
        return new Observable(function (observer) {
            var active = [];
            var queue = [];
            function checkForComplete() {
                if (active.length === 0 && queue.length === 0) {
                    observer.complete();
                }
                else if (queue.length > 0 && active.length < concurrent) {
                    var item = queue.shift();
                    if (isSubscribable(item)) {
                        var itemIndex_1 = active.length;
                        active.push(item);
                        item.subscribe({
                            next: function (value) {
                                observer.next(value);
                            },
                            complete: function () {
                                active.splice(itemIndex_1, 1);
                                checkForComplete();
                            }
                        });
                    }
                    else {
                        observer.next(item);
                        checkForComplete();
                    }
                }
            }
            self.subscribe({
                next: function (value) {
                    queue.push(value);
                },
                complete: function () {
                    checkForComplete();
                }
            });
        });
    };
    return Observable;
}(Observable_1.default));
exports.Observable = Observable;
exports.default = Observable;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lang_1 = __webpack_require__(8);
/**
 * Parses a query string, returning a ParamList object.
 */
function parseQueryString(input) {
    var query = {};
    for (var _i = 0, _a = input.split('&'); _i < _a.length; _i++) {
        var entry = _a[_i];
        var indexOfFirstEquals = entry.indexOf('=');
        var key = void 0;
        var value = '';
        if (indexOfFirstEquals >= 0) {
            key = entry.slice(0, indexOfFirstEquals);
            value = entry.slice(indexOfFirstEquals + 1);
        }
        else {
            key = entry;
        }
        key = key ? decodeURIComponent(key) : '';
        value = value ? decodeURIComponent(value) : '';
        if (key in query) {
            query[key].push(value);
        }
        else {
            query[key] = [value];
        }
    }
    return query;
}
/**
 * Represents a set of URL query search parameters.
 */
var UrlSearchParams = (function () {
    /**
     * Constructs a new UrlSearchParams from a query string, an object of parameters and values, or another
     * UrlSearchParams.
     */
    function UrlSearchParams(input) {
        var list;
        if (input instanceof UrlSearchParams) {
            // Copy the incoming UrlSearchParam's internal list
            list = lang_1.duplicate(input._list);
        }
        else if (typeof input === 'object') {
            // Copy the incoming object, assuming its property values are either arrays or strings
            list = {};
            for (var key in input) {
                var value = input[key];
                if (Array.isArray(value)) {
                    list[key] = value.length ? value.slice() : [''];
                }
                else if (value == null) {
                    list[key] = [''];
                }
                else {
                    list[key] = [value];
                }
            }
        }
        else if (typeof input === 'string') {
            // Parse the incoming string as a query string
            list = parseQueryString(input);
        }
        else {
            list = {};
        }
        Object.defineProperty(this, '_list', { value: list });
    }
    /**
     * Appends a new value to the set of values for a key.
     * @param key The key to add a value for
     * @param value The value to add
     */
    UrlSearchParams.prototype.append = function (key, value) {
        if (!this.has(key)) {
            this.set(key, value);
        }
        else {
            var values = this._list[key];
            if (values) {
                values.push(value);
            }
        }
    };
    /**
     * Deletes all values for a key.
     * @param key The key whose values are to be removed
     */
    UrlSearchParams.prototype.delete = function (key) {
        // Set to undefined rather than deleting the key, for better consistency across browsers.
        // If a deleted key is re-added, most browsers put it at the end of iteration order, but IE maintains
        // its original position.  This approach maintains the original position everywhere.
        this._list[key] = undefined;
    };
    /**
     * Returns the first value associated with a key.
     * @param key The key to return the first value for
     * @return The first string value for the key
     */
    UrlSearchParams.prototype.get = function (key) {
        if (!this.has(key)) {
            return undefined;
        }
        var value = this._list[key];
        return value ? value[0] : undefined;
    };
    /**
     * Returns all the values associated with a key.
     * @param key The key to return all values for
     * @return An array of strings containing all values for the key
     */
    UrlSearchParams.prototype.getAll = function (key) {
        if (!this.has(key)) {
            return undefined;
        }
        return this._list[key];
    };
    /**
     * Returns true if a key has been set to any value, false otherwise.
     * @param key The key to test for existence
     * @return A boolean indicating if the key has been set
     */
    UrlSearchParams.prototype.has = function (key) {
        return Array.isArray(this._list[key]);
    };
    /**
     * Returns an array of all keys which have been set.
     * @return An array of strings containing all keys set in the UrlSearchParams instance
     */
    UrlSearchParams.prototype.keys = function () {
        var keys = [];
        for (var key in this._list) {
            if (this.has(key)) {
                keys.push(key);
            }
        }
        return keys;
    };
    /**
     * Sets the value associated with a key.
     * @param key The key to set the value of
     */
    UrlSearchParams.prototype.set = function (key, value) {
        this._list[key] = [value];
    };
    /**
     * Returns this object's data as an encoded query string.
     * @return A string in application/x-www-form-urlencoded format containing all of the set keys/values
     */
    UrlSearchParams.prototype.toString = function () {
        var query = [];
        for (var key in this._list) {
            if (!this.has(key)) {
                continue;
            }
            var values = this._list[key];
            if (values) {
                var encodedKey = encodeURIComponent(key);
                for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                    var value = values_1[_i];
                    query.push(encodedKey + (value ? ('=' + encodeURIComponent(value)) : ''));
                }
            }
        }
        return query.join('&');
    };
    return UrlSearchParams;
}());
exports.default = UrlSearchParams;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var iterator_1 = __webpack_require__(2);
var Promise_1 = __webpack_require__(4);
__webpack_require__(3);
/**
 * Take a list of values, and if any are ExtensiblePromise objects, insert the wrapped Promise in its place,
 * otherwise use the original object. We use this to help use the native Promise methods like `all` and `race`.
 *
 * @param iterable    The list of objects to iterate over
 * @returns {any[]}    The list of objects, as an array, with ExtensiblePromises being replaced by Promises.
 */
function unwrapPromises(iterable) {
    var unwrapped = [];
    iterator_1.forOf(iterable, function (item) {
        unwrapped.push(item instanceof ExtensiblePromise ? item._promise : item);
    });
    return unwrapped;
}
exports.unwrapPromises = unwrapPromises;
/**
 * An extensible base to allow Promises to be extended in ES5. This class basically wraps a native Promise object,
 * giving an API like a native promise.
 */
var ExtensiblePromise = (function () {
    /**
     * Creates a new extended Promise.
     *
     * @constructor
     *
     * @param executor
     * The executor function is called immediately when the Promise is instantiated. It is responsible for
     * starting the asynchronous operation when it is invoked.
     *
     * The executor must call either the passed `resolve` function when the asynchronous operation has completed
     * successfully, or the `reject` function when the operation fails.
     */
    function ExtensiblePromise(executor) {
        this._promise = new Promise_1.default(executor);
    }
    /**
     * Return a rejected promise wrapped in an ExtensiblePromise
     *
     * @param reason    The reason for the rejection
     * @returns An extensible promise
     */
    ExtensiblePromise.reject = function (reason) {
        return new this(function (resolve, reject) { return reject(reason); });
    };
    ExtensiblePromise.resolve = function (value) {
        return new this(function (resolve, reject) { return resolve(value); });
    };
    /**
     * Return a ExtensiblePromise that resolves when all of the passed in objects have resolved. When used with a key/value
     * pair, the returned promise's argument is a key/value pair of the original keys with their resolved values.
     *
     * @example
     * ExtensiblePromise.all({ one: 1, two: 2 }).then(results => console.log(results));
     * // { one: 1, two: 2 }
     *
     * @param iterable    An iterable of values to resolve, or a key/value pair of values to resolve. These can be Promises, ExtensiblePromises, or other objects
     * @returns An extensible promise
     */
    ExtensiblePromise.all = function (iterable) {
        if (!iterator_1.isArrayLike(iterable) && !iterator_1.isIterable(iterable)) {
            var promiseKeys_1 = Object.keys(iterable);
            return new this(function (resolve, reject) {
                Promise_1.default.all(promiseKeys_1.map(function (key) { return iterable[key]; })).then(function (promiseResults) {
                    var returnValue = {};
                    promiseResults.forEach(function (value, index) {
                        returnValue[promiseKeys_1[index]] = value;
                    });
                    resolve(returnValue);
                }, reject);
            });
        }
        return new this(function (resolve, reject) {
            Promise_1.default.all(unwrapPromises(iterable)).then(resolve, reject);
        });
    };
    /**
     * Return a ExtensiblePromise that resolves when one of the passed in objects have resolved
     *
     * @param iterable    An iterable of values to resolve. These can be Promises, ExtensiblePromises, or other objects
     * @returns {ExtensiblePromise}
     */
    ExtensiblePromise.race = function (iterable) {
        return new this(function (resolve, reject) {
            Promise_1.default.race(unwrapPromises(iterable)).then(resolve, reject);
        });
    };
    /**
     * Adds a callback to be invoked when the wrapped Promise is rejected.
     *
     * @param {Function} onRejected A function to call to handle the error. The parameter to the function will be the caught error.
     *
     * @returns {ExtensiblePromise}
     */
    ExtensiblePromise.prototype.catch = function (onRejected) {
        return this.then(undefined, onRejected);
    };
    /**
     * Adds a callback to be invoked when the wrapped Promise resolves or is rejected.
     *
     * @param {Function} onFulfilled   A function to call to handle the resolution. The paramter to the function will be the resolved value, if any.
     * @param {Function} onRejected    A function to call to handle the error. The parameter to the function will be the caught error.
     *
     * @returns {ExtensiblePromise}
     */
    ExtensiblePromise.prototype.then = function (onFulfilled, onRejected) {
        var _this = this;
        var executor = function (resolve, reject) {
            function handler(rejected, valueOrError) {
                var callback = rejected ? onRejected : onFulfilled;
                if (typeof callback === 'function') {
                    try {
                        resolve(callback(valueOrError));
                    }
                    catch (error) {
                        reject(error);
                    }
                }
                else if (rejected) {
                    reject(valueOrError);
                }
                else {
                    resolve(valueOrError);
                }
            }
            _this._promise.then(handler.bind(null, false), handler.bind(null, true));
        };
        return new this.constructor(executor);
    };
    return ExtensiblePromise;
}());
exports.default = ExtensiblePromise;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = __webpack_require__(0);
var has_1 = __webpack_require__(1);
__export(__webpack_require__(1));
exports.default = has_1.default;
has_1.add('object-assign', typeof global_1.default.Object.assign === 'function', true);
has_1.add('arraybuffer', typeof global_1.default.ArrayBuffer !== 'undefined', true);
has_1.add('formdata', typeof global_1.default.FormData !== 'undefined', true);
has_1.add('filereader', typeof global_1.default.FileReader !== 'undefined', true);
has_1.add('xhr', typeof global_1.default.XMLHttpRequest !== 'undefined', true);
has_1.add('xhr2', has_1.default('xhr') && 'responseType' in global_1.default.XMLHttpRequest.prototype, true);
has_1.add('blob', function () {
    if (!has_1.default('xhr2')) {
        return false;
    }
    var request = new global_1.default.XMLHttpRequest();
    request.open('GET', 'http://www.google.com', true);
    request.responseType = 'blob';
    request.abort();
    return request.responseType === 'blob';
}, true);
has_1.add('node-buffer', 'Buffer' in global_1.default && typeof global_1.default.Buffer === 'function', true);
has_1.add('fetch', 'fetch' in global_1.default && typeof global_1.default.fetch === 'function', true);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var iterator_1 = __webpack_require__(2);
var Map_1 = __webpack_require__(25);
function isHeadersLike(object) {
    return typeof object.append === 'function' && typeof object.entries === 'function' && typeof object[Symbol.iterator] === 'function';
}
var Headers = (function () {
    function Headers(headers) {
        var _this = this;
        this.map = new Map_1.default();
        if (headers) {
            if (headers instanceof Headers) {
                this.map = new Map_1.default(headers.map);
            }
            else if (isHeadersLike(headers)) {
                iterator_1.forOf(headers, function (_a) {
                    var key = _a[0], value = _a[1];
                    _this.append(key, value);
                });
            }
            else {
                for (var key in headers) {
                    this.set(key, headers[key]);
                }
            }
        }
    }
    Headers.prototype.append = function (name, value) {
        var values = this.map.get(name.toLowerCase());
        if (values) {
            values.push(value);
        }
        else {
            this.set(name, value);
        }
    };
    Headers.prototype.delete = function (name) {
        this.map.delete(name.toLowerCase());
    };
    Headers.prototype.entries = function () {
        var entries = [];
        iterator_1.forOf(this.map.entries(), function (_a) {
            var key = _a[0], values = _a[1];
            values.forEach(function (value) {
                entries.push([key, value]);
            });
        });
        return new iterator_1.ShimIterator(entries);
    };
    Headers.prototype.get = function (name) {
        var values = this.map.get(name.toLowerCase());
        if (values) {
            return values[0];
        }
        else {
            return null;
        }
    };
    Headers.prototype.getAll = function (name) {
        var values = this.map.get(name.toLowerCase());
        if (values) {
            return values.slice(0);
        }
        else {
            return [];
        }
    };
    Headers.prototype.has = function (name) {
        return this.map.has(name.toLowerCase());
    };
    Headers.prototype.keys = function () {
        return this.map.keys();
    };
    Headers.prototype.set = function (name, value) {
        this.map.set(name.toLowerCase(), [value]);
    };
    Headers.prototype.values = function () {
        var values = [];
        iterator_1.forOf(this.map.values(), function (value) {
            values.push.apply(values, value);
        });
        return new iterator_1.ShimIterator(values);
    };
    Headers.prototype[Symbol.iterator] = function () {
        return this.entries();
    };
    return Headers;
}());
exports.default = Headers;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Promise_1 = __webpack_require__(4);
var Response = (function () {
    function Response() {
    }
    Response.prototype.json = function () {
        return this.text().then(JSON.parse);
    };
    return Response;
}());
exports.default = Response;
function getFileReaderPromise(reader) {
    return new Promise_1.default(function (resolve, reject) {
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.onerror = function () {
            reject(reader.error);
        };
    });
}
exports.getFileReaderPromise = getFileReaderPromise;
function getTextFromBlob(blob) {
    var reader = new FileReader();
    var promise = getFileReaderPromise(reader);
    reader.readAsText(blob);
    return promise;
}
exports.getTextFromBlob = getTextFromBlob;
function getArrayBufferFromBlob(blob) {
    var reader = new FileReader();
    var promise = getFileReaderPromise(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
exports.getArrayBufferFromBlob = getArrayBufferFromBlob;
function getTextFromArrayBuffer(buffer) {
    var view = new Uint8Array(buffer);
    var chars = [];
    view.forEach(function (charCode, index) {
        chars[index] = String.fromCharCode(charCode);
    });
    return chars.join('');
}
exports.getTextFromArrayBuffer = getTextFromArrayBuffer;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionPool = (function () {
    function SubscriptionPool(maxLength) {
        if (maxLength === void 0) { maxLength = 10; }
        this._observers = [];
        this._queue = [];
        this._queueMaxLength = maxLength;
    }
    SubscriptionPool.prototype.add = function (subscription) {
        var _this = this;
        this._observers.push(subscription);
        while (this._queue.length > 0) {
            this.next(this._queue.shift());
        }
        return function () {
            _this._observers.splice(_this._observers.indexOf(subscription), 1);
        };
    };
    SubscriptionPool.prototype.next = function (value) {
        if (this._observers.length === 0) {
            this._queue.push(value);
            // when the queue is full, get rid of the first ones
            while (this._queue.length > this._queueMaxLength) {
                this._queue.shift();
            }
        }
        this._observers.forEach(function (observer) {
            observer.next(value);
        });
    };
    SubscriptionPool.prototype.complete = function () {
        this._observers.forEach(function (observer) {
            observer.complete();
        });
    };
    return SubscriptionPool;
}());
exports.default = SubscriptionPool;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TimeoutError = (function () {
    function TimeoutError(message) {
        message = message || 'The request timed out';
        this.message = message;
    }
    Object.defineProperty(TimeoutError.prototype, "name", {
        get: function () {
            return 'TimeoutError';
        },
        enumerable: true,
        configurable: true
    });
    return TimeoutError;
}());
exports.default = TimeoutError;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = __webpack_require__(0);
var iterator_1 = __webpack_require__(2);
var WeakMap_1 = __webpack_require__(27);
var Task_1 = __webpack_require__(7);
var has_1 = __webpack_require__(17);
var util_1 = __webpack_require__(24);
var Headers_1 = __webpack_require__(18);
var Response_1 = __webpack_require__(19);
var TimeoutError_1 = __webpack_require__(21);
var util_2 = __webpack_require__(23);
var Observable_1 = __webpack_require__(14);
var SubscriptionPool_1 = __webpack_require__(20);
var dataMap = new WeakMap_1.default();
function getDataTask(response) {
    var data = dataMap.get(response);
    if (data.used) {
        return Task_1.default.reject(new TypeError('Body already read'));
    }
    data.used = true;
    return data.task;
}
/**
 * Wraps an XHR request in a response that mimics the fetch API
 */
var XhrResponse = (function (_super) {
    __extends(XhrResponse, _super);
    function XhrResponse(request) {
        var _this = _super.call(this) || this;
        var headers = _this.headers = new Headers_1.default();
        var responseHeaders = request.getAllResponseHeaders();
        if (responseHeaders) {
            for (var _i = 0, _a = responseHeaders.split(/\r\n/g); _i < _a.length; _i++) {
                var line = _a[_i];
                var match = line.match(/^(.*?): (.*)$/);
                if (match) {
                    headers.append(match[1], match[2]);
                }
            }
        }
        _this.status = request.status;
        _this.ok = _this.status >= 200 && _this.status < 300;
        _this.statusText = request.statusText || 'OK';
        return _this;
    }
    Object.defineProperty(XhrResponse.prototype, "bodyUsed", {
        get: function () {
            return dataMap.get(this).used;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XhrResponse.prototype, "nativeResponse", {
        get: function () {
            return dataMap.get(this).nativeResponse;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XhrResponse.prototype, "requestOptions", {
        get: function () {
            return dataMap.get(this).requestOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XhrResponse.prototype, "url", {
        get: function () {
            return dataMap.get(this).url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XhrResponse.prototype, "download", {
        get: function () {
            return dataMap.get(this).downloadObservable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XhrResponse.prototype, "data", {
        get: function () {
            return dataMap.get(this).dataObservable;
        },
        enumerable: true,
        configurable: true
    });
    XhrResponse.prototype.arrayBuffer = function () {
        return Task_1.default.reject(new Error('ArrayBuffer not supported'));
    };
    XhrResponse.prototype.blob = function () {
        return Task_1.default.reject(new Error('Blob not supported'));
    };
    XhrResponse.prototype.formData = function () {
        return Task_1.default.reject(new Error('FormData not supported'));
    };
    XhrResponse.prototype.text = function () {
        return getDataTask(this).then(function (request) {
            return String(request.responseText);
        });
    };
    XhrResponse.prototype.xml = function () {
        var _this = this;
        return this.text().then(function (text) {
            var parser = new DOMParser();
            return parser.parseFromString(text, _this.headers.get('content-type') || 'text/html');
        });
    };
    return XhrResponse;
}(Response_1.default));
exports.XhrResponse = XhrResponse;
if (has_1.default('blob')) {
    XhrResponse.prototype.blob = function () {
        return getDataTask(this).then(function (request) { return request.response; });
    };
    XhrResponse.prototype.text = function () {
        return this.blob().then(Response_1.getTextFromBlob);
    };
    if (has_1.default('arraybuffer')) {
        XhrResponse.prototype.arrayBuffer = function () {
            return this.blob().then(Response_1.getArrayBufferFromBlob);
        };
    }
}
if (has_1.default('formdata')) {
    XhrResponse.prototype.formData = function () {
        return this.text().then(function (text) {
            var data = new FormData();
            text.trim().split('&').forEach(function (keyValues) {
                if (keyValues) {
                    var pairs = keyValues.split('=');
                    var name_1 = (pairs.shift() || '').replace(/\+/, ' ');
                    var value = pairs.join('=').replace(/\+/, ' ');
                    data.append(decodeURIComponent(name_1), decodeURIComponent(value));
                }
            });
            return data;
        });
    };
}
function noop() { }
function setOnError(request, reject) {
    request.addEventListener('error', function (event) {
        reject(new TypeError(event.error || 'Network request failed'));
    });
}
function xhr(url, options) {
    if (options === void 0) { options = {}; }
    var request = new XMLHttpRequest();
    var requestUrl = util_2.generateRequestUrl(url, options);
    options = Object.create(options);
    if (!options.method) {
        options.method = 'GET';
    }
    var isAborted = false;
    function abort() {
        isAborted = true;
        if (request) {
            request.abort();
            request.onreadystatechange = noop;
        }
    }
    var timeoutHandle;
    var timeoutReject;
    var task = new Task_1.default(function (resolve, reject) {
        timeoutReject = reject;
        request.onreadystatechange = function () {
            if (isAborted) {
                return;
            }
            if (request.readyState === 2) {
                var response = new XhrResponse(request);
                var downloadSubscriptionPool_1 = new SubscriptionPool_1.default();
                var dataSubscriptionPool_1 = new SubscriptionPool_1.default();
                var task_1 = new Task_1.default(function (resolve, reject) {
                    timeoutReject = reject;
                    request.onprogress = function (event) {
                        if (isAborted) {
                            return;
                        }
                        downloadSubscriptionPool_1.next(event.loaded);
                    };
                    request.onreadystatechange = function () {
                        if (isAborted) {
                            return;
                        }
                        if (request.readyState === 4) {
                            request.onreadystatechange = noop;
                            timeoutHandle && timeoutHandle.destroy();
                            dataSubscriptionPool_1.next(request.response);
                            dataSubscriptionPool_1.complete();
                            resolve(request);
                        }
                    };
                    setOnError(request, reject);
                }, abort);
                dataMap.set(response, {
                    task: task_1,
                    used: false,
                    nativeResponse: request,
                    requestOptions: options,
                    url: requestUrl,
                    downloadObservable: new Observable_1.default(function (observer) { return downloadSubscriptionPool_1.add(observer); }),
                    dataObservable: new Observable_1.default(function (observer) { return dataSubscriptionPool_1.add(observer); })
                });
                resolve(response);
            }
        };
        setOnError(request, reject);
    }, abort);
    request.open(options.method, requestUrl, !options.blockMainThread, options.user, options.password);
    if (has_1.default('filereader') && has_1.default('blob')) {
        request.responseType = 'blob';
    }
    if (options.timeout && options.timeout > 0 && options.timeout !== Infinity) {
        timeoutHandle = util_1.createTimer(function () {
            // Reject first, since aborting will also fire onreadystatechange which would reject with a
            // less specific error.  (This is also why we set up our own timeout rather than using
            // native timeout and ontimeout, because that aborts and fires onreadystatechange before ontimeout.)
            timeoutReject && timeoutReject(new TimeoutError_1.default('The XMLHttpRequest request timed out'));
            abort();
        }, options.timeout);
    }
    var hasContentTypeHeader = false;
    var hasRequestedWithHeader = false;
    var _a = options.includeRequestedWithHeader, includeRequestedWithHeader = _a === void 0 ? true : _a;
    if (options.headers) {
        var requestHeaders = new Headers_1.default(options.headers);
        hasRequestedWithHeader = requestHeaders.has('x-requested-with');
        hasContentTypeHeader = requestHeaders.has('content-type');
        iterator_1.forOf(requestHeaders, function (_a) {
            var key = _a[0], value = _a[1];
            request.setRequestHeader(key, value);
        });
    }
    if (!hasRequestedWithHeader && includeRequestedWithHeader) {
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    if (!hasContentTypeHeader && has_1.default('formdata') && options.body instanceof global_1.default.FormData) {
        // Assume that most forms do not contain large binary files. If that is not the case,
        // then "multipart/form-data" should be manually specified as the "Content-Type" header.
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    task.finally(function () {
        if (task.state !== 0 /* Fulfilled */) {
            request.onreadystatechange = noop;
            timeoutHandle && timeoutHandle.destroy();
        }
    });
    var uploadObserverPool = new SubscriptionPool_1.default();
    task.upload = new Observable_1.default(function (observer) { return uploadObserverPool.add(observer); });
    request.upload.addEventListener('progress', function (event) {
        uploadObserverPool.next(event.loaded);
    });
    request.send(options.body || null);
    return task;
}
exports.default = xhr;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UrlSearchParams_1 = __webpack_require__(15);
var iterator_1 = __webpack_require__(2);
/**
 * Returns a URL formatted with optional query string and cache-busting segments.
 *
 * @param url The base URL.
 * @param options The RequestOptions used to generate the query string or cacheBust.
 */
function generateRequestUrl(url, _a) {
    var _b = _a === void 0 ? {} : _a, query = _b.query, cacheBust = _b.cacheBust;
    query = new UrlSearchParams_1.default(query).toString();
    if (cacheBust) {
        var bustString = String(Date.now());
        query += query ? "&" + bustString : bustString;
    }
    var separator = url.indexOf('?') > -1 ? '&' : '?';
    return query ? "" + url + separator + query : url;
}
exports.generateRequestUrl = generateRequestUrl;
function getStringFromFormData(formData) {
    var fields = [];
    iterator_1.forOf(formData.keys(), function (key) {
        fields.push(encodeURIComponent(key) + '=' + encodeURIComponent(formData.get(key)));
    });
    return fields.join('&');
}
exports.getStringFromFormData = getStringFromFormData;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lang_1 = __webpack_require__(8);
/**
 * Wraps a setTimeout call in a handle, allowing the timeout to be cleared by calling destroy.
 *
 * @param callback Callback to be called when the timeout elapses
 * @param delay Number of milliseconds to wait before calling the callback
 * @return Handle which can be destroyed to clear the timeout
 */
function createTimer(callback, delay) {
    var timerId = setTimeout(callback, delay);
    return lang_1.createHandle(function () {
        if (timerId) {
            clearTimeout(timerId);
            timerId = null;
        }
    });
}
exports.createTimer = createTimer;
/**
 * Wraps a callback, returning a function which fires after no further calls are received over a set interval.
 *
 * @param callback Callback to wrap
 * @param delay Number of milliseconds to wait after any invocations before calling the original callback
 * @return Debounced function
 */
function debounce(callback, delay) {
    // node.d.ts clobbers setTimeout/clearTimeout with versions that return/receive NodeJS.Timer,
    // but browsers return/receive a number
    var timer;
    return function () {
        timer && clearTimeout(timer);
        var context = this;
        var args = arguments;
        timer = setTimeout(function () {
            callback.apply(context, args);
            args = context = timer = null;
        }, delay);
    };
}
exports.debounce = debounce;
/**
 * Wraps a callback, returning a function which fires at most once per set interval.
 *
 * @param callback Callback to wrap
 * @param delay Number of milliseconds to wait before allowing the original callback to be called again
 * @return Throttled function
 */
function throttle(callback, delay) {
    var ran;
    return function () {
        if (ran) {
            return;
        }
        ran = true;
        callback.apply(this, arguments);
        setTimeout(function () {
            ran = null;
        }, delay);
    };
}
exports.throttle = throttle;
/**
 * Like throttle, but calls the callback at the end of each interval rather than the beginning.
 * Useful for e.g. resize or scroll events, when debounce would appear unresponsive.
 *
 * @param callback Callback to wrap
 * @param delay Number of milliseconds to wait before calling the original callback and allowing it to be called again
 * @return Throttled function
 */
function throttleAfter(callback, delay) {
    var ran;
    return function () {
        if (ran) {
            return;
        }
        ran = true;
        var context = this;
        var args = arguments;
        setTimeout(function () {
            callback.apply(context, args);
            args = context = ran = null;
        }, delay);
    };
}
exports.throttleAfter = throttleAfter;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var iterator_1 = __webpack_require__(2);
var global_1 = __webpack_require__(0);
var object_1 = __webpack_require__(5);
var has_1 = __webpack_require__(1);
__webpack_require__(3);
exports.Map = global_1.default.Map;
if (!has_1.default('es6-map')) {
    exports.Map = (_a = (function () {
            function Map(iterable) {
                var _this = this;
                this._keys = [];
                this._values = [];
                this[Symbol.toStringTag] = 'Map';
                if (iterable) {
                    iterator_1.forOf(iterable, function (value) {
                        _this.set(value[0], value[1]);
                    });
                }
            }
            /**
             * An alternative to Array.prototype.indexOf using Object.is
             * to check for equality. See http://mzl.la/1zuKO2V
             */
            Map.prototype._indexOfKey = function (keys, key) {
                for (var i = 0, length_1 = keys.length; i < length_1; i++) {
                    if (object_1.is(keys[i], key)) {
                        return i;
                    }
                }
                return -1;
            };
            Object.defineProperty(Map.prototype, "size", {
                get: function () {
                    return this._keys.length;
                },
                enumerable: true,
                configurable: true
            });
            Map.prototype.clear = function () {
                this._keys.length = this._values.length = 0;
            };
            Map.prototype.delete = function (key) {
                var index = this._indexOfKey(this._keys, key);
                if (index < 0) {
                    return false;
                }
                this._keys.splice(index, 1);
                this._values.splice(index, 1);
                return true;
            };
            Map.prototype.entries = function () {
                var _this = this;
                var values = this._keys.map(function (key, i) {
                    return [key, _this._values[i]];
                });
                return new iterator_1.ShimIterator(values);
            };
            Map.prototype.forEach = function (callback, context) {
                var keys = this._keys;
                var values = this._values;
                for (var i = 0, length_2 = keys.length; i < length_2; i++) {
                    callback.call(context, values[i], keys[i], this);
                }
            };
            Map.prototype.get = function (key) {
                var index = this._indexOfKey(this._keys, key);
                return index < 0 ? undefined : this._values[index];
            };
            Map.prototype.has = function (key) {
                return this._indexOfKey(this._keys, key) > -1;
            };
            Map.prototype.keys = function () {
                return new iterator_1.ShimIterator(this._keys);
            };
            Map.prototype.set = function (key, value) {
                var index = this._indexOfKey(this._keys, key);
                index = index < 0 ? this._keys.length : index;
                this._keys[index] = key;
                this._values[index] = value;
                return this;
            };
            Map.prototype.values = function () {
                return new iterator_1.ShimIterator(this._values);
            };
            Map.prototype[Symbol.iterator] = function () {
                return this.entries();
            };
            return Map;
        }()),
        _a[Symbol.species] = _a,
        _a);
}
exports.default = exports.Map;
var _a;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = __webpack_require__(0);
var iterator_1 = __webpack_require__(2);
var has_1 = __webpack_require__(1);
__webpack_require__(3);
exports.Observable = global_1.default.Observable;
if (!has_1.default('es-observable')) {
    /*
     * Create a subscription observer for a given observer, and return the subscription.  The "logic" for Observerables
     * is in here!
     */
    var startSubscription_1 = function startSubscription(executor, observer) {
        var closed = false;
        var cleanUp;
        function unsubscribe() {
            if (!closed) {
                closed = true;
                if (cleanUp) {
                    cleanUp();
                }
            }
        }
        function start(subscriptionObserver) {
            if (observer.start) {
                observer.start(subscription);
            }
            if (closed) {
                return;
            }
            try {
                var result = executor(subscriptionObserver);
                if (typeof result === 'function') {
                    cleanUp = result;
                }
                else if (result && 'unsubscribe' in result) {
                    cleanUp = result.unsubscribe;
                }
                else if (result !== undefined && result !== null) {
                    throw new TypeError('Subscriber must return a callable or subscription');
                }
                if (closed) {
                    if (cleanUp) {
                        cleanUp();
                    }
                }
            }
            catch (e) {
                error(e);
            }
        }
        function next(value) {
            if (closed) {
                return;
            }
            var next = observer.next;
            try {
                if (typeof next === 'function') {
                    return next(value);
                }
                else if (next !== undefined && next !== null) {
                    throw new TypeError('Observer.next is not a function');
                }
            }
            catch (e) {
                error(e);
            }
        }
        function error(errorValue) {
            if (!closed) {
                var cleanUpError = undefined;
                try {
                    unsubscribe();
                }
                catch (e) {
                    cleanUpError = e;
                }
                var observerError = observer.error;
                if (observerError !== undefined && observerError !== null) {
                    if (typeof observerError === 'function') {
                        var errorResult = observerError(errorValue);
                        if (cleanUpError !== undefined) {
                            throw cleanUpError;
                        }
                        return errorResult;
                    }
                    else {
                        throw new TypeError('Observer.error is not a function');
                    }
                }
                else if (observer.complete) {
                    return observer.complete(errorValue);
                }
                else {
                    throw errorValue;
                }
            }
            else {
                throw errorValue;
            }
        }
        function complete(completeValue) {
            if (!closed) {
                var cleanUpError = undefined;
                try {
                    unsubscribe();
                }
                catch (e) {
                    cleanUpError = e;
                }
                var observerComplete = observer.complete;
                if (observerComplete !== undefined && observerComplete !== null) {
                    if (typeof observerComplete === 'function') {
                        var completeResult = observerComplete(completeValue);
                        if (cleanUpError !== undefined) {
                            throw cleanUpError;
                        }
                        return completeResult;
                    }
                    else {
                        throw new TypeError('Observer.complete is not a function');
                    }
                }
                else if (cleanUpError) {
                    throw cleanUpError;
                }
            }
        }
        var subscription = Object.create(Object.create({}, {
            'closed': {
                enumerable: false,
                configurable: true,
                get: function () {
                    return closed;
                }
            },
            'unsubscribe': {
                enumerable: false,
                configurable: true,
                writable: true,
                value: unsubscribe
            }
        }));
        var prototype = Object.create({}, {
            'next': {
                enumerable: false,
                writable: true,
                value: next,
                configurable: true
            },
            'error': {
                enumerable: false,
                writable: true,
                value: error,
                configurable: true
            },
            'complete': {
                enumerable: false,
                writable: true,
                value: complete,
                configurable: true
            },
            'closed': {
                enumerable: false,
                configurable: true,
                get: function () {
                    return closed;
                }
            }
        });
        // create the SubscriptionObserver and kick things off
        start(Object.create(prototype));
        // the ONLY way to control the SubscriptionObserver is with the subscription or from a subscriber
        return subscription;
    };
    exports.Observable = (function () {
        function nonEnumerable(target, key, descriptor) {
            descriptor.enumerable = false;
        }
        var Observable = (function () {
            function Observable(subscriber) {
                if (typeof subscriber !== 'function') {
                    throw new TypeError('subscriber is not a function');
                }
                this._executor = subscriber;
            }
            Observable.prototype[_a = Symbol.observable] = function () {
                return this;
            };
            Observable.prototype.subscribe = function (observerOrNext) {
                var listeners = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    listeners[_i - 1] = arguments[_i];
                }
                var _a = listeners.slice(), onError = _a[0], onComplete = _a[1];
                if (!observerOrNext || typeof observerOrNext === 'number' || typeof observerOrNext === 'string' || typeof observerOrNext === 'boolean') {
                    throw new TypeError('parameter must be a function or an observer');
                }
                var observer;
                if (typeof observerOrNext === 'function') {
                    observer = {
                        next: observerOrNext
                    };
                    if (typeof onError === 'function') {
                        observer.error = onError;
                    }
                    if (typeof onComplete === 'function') {
                        observer.complete = onComplete;
                    }
                }
                else {
                    observer = observerOrNext;
                }
                return startSubscription_1(this._executor, observer);
            };
            Observable.of = function () {
                var items = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    items[_i] = arguments[_i];
                }
                var constructor;
                if (typeof this !== 'function') {
                    constructor = Observable;
                }
                else {
                    constructor = this;
                }
                return new constructor(function (observer) {
                    iterator_1.forOf(items, function (o) {
                        observer.next(o);
                    });
                    observer.complete();
                });
            };
            Observable.from = function (item) {
                if (item === null || item === undefined) {
                    throw new TypeError('item cannot be null or undefined');
                }
                var constructor;
                if (typeof this !== 'function') {
                    constructor = Observable;
                }
                else {
                    constructor = this;
                }
                var observableSymbol = item[Symbol.observable];
                if (observableSymbol !== undefined) {
                    if (typeof observableSymbol !== 'function') {
                        throw new TypeError('Symbol.observable must be a function');
                    }
                    var result = observableSymbol.call(item);
                    if (result === undefined || result === null || typeof result === 'number' || typeof result === 'boolean' || typeof result === 'string') {
                        throw new TypeError('Return value of Symbol.observable must be object');
                    }
                    if (result.constructor && result.constructor === this || result instanceof Observable) {
                        return result;
                    }
                    else if (result.subscribe) {
                        return new constructor(result.subscribe);
                    }
                    else {
                        if (constructor.of) {
                            return constructor.of(result);
                        }
                        else {
                            return Observable.of(result);
                        }
                    }
                }
                else if (iterator_1.isIterable(item) || iterator_1.isArrayLike(item)) {
                    return new constructor(function (observer) {
                        iterator_1.forOf(item, function (o) {
                            observer.next(o);
                        });
                        observer.complete();
                    });
                }
                else {
                    throw new TypeError('Parameter is neither Observable nor Iterable');
                }
            };
            __decorate([
                nonEnumerable
            ], Observable.prototype, _a, null);
            __decorate([
                nonEnumerable
            ], Observable.prototype, "subscribe", null);
            __decorate([
                nonEnumerable
            ], Observable, "of", null);
            __decorate([
                nonEnumerable
            ], Observable, "from", null);
            return Observable;
            var _a;
        }());
        return Observable;
    })();
}
exports.default = exports.Observable;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = __webpack_require__(0);
var iterator_1 = __webpack_require__(2);
var has_1 = __webpack_require__(1);
__webpack_require__(3);
exports.WeakMap = global_1.default.WeakMap;
if (!has_1.default('es6-weakmap')) {
    var DELETED_1 = {};
    var getUID_1 = function getUID() {
        return Math.floor(Math.random() * 100000000);
    };
    var generateName_1 = (function () {
        var startId = Math.floor(Date.now() % 100000000);
        return function generateName() {
            return '__wm' + getUID_1() + (startId++ + '__');
        };
    })();
    exports.WeakMap = (function () {
        function WeakMap(iterable) {
            var _this = this;
            this[Symbol.toStringTag] = 'WeakMap';
            Object.defineProperty(this, '_name', {
                value: generateName_1()
            });
            this._frozenEntries = [];
            if (iterable) {
                iterator_1.forOf(iterable, function (_a) {
                    var key = _a[0], value = _a[1];
                    return _this.set(key, value);
                });
            }
        }
        WeakMap.prototype._getFrozenEntryIndex = function (key) {
            for (var i = 0; i < this._frozenEntries.length; i++) {
                if (this._frozenEntries[i].key === key) {
                    return i;
                }
            }
            return -1;
        };
        WeakMap.prototype.delete = function (key) {
            if (key === undefined || key === null) {
                return false;
            }
            var entry = key[this._name];
            if (entry && entry.key === key && entry.value !== DELETED_1) {
                entry.value = DELETED_1;
                return true;
            }
            var frozenIndex = this._getFrozenEntryIndex(key);
            if (frozenIndex >= 0) {
                this._frozenEntries.splice(frozenIndex, 1);
                return true;
            }
            return false;
        };
        WeakMap.prototype.get = function (key) {
            if (key === undefined || key === null) {
                return undefined;
            }
            var entry = key[this._name];
            if (entry && entry.key === key && entry.value !== DELETED_1) {
                return entry.value;
            }
            var frozenIndex = this._getFrozenEntryIndex(key);
            if (frozenIndex >= 0) {
                return this._frozenEntries[frozenIndex].value;
            }
        };
        WeakMap.prototype.has = function (key) {
            if (key === undefined || key === null) {
                return false;
            }
            var entry = key[this._name];
            if (Boolean(entry && entry.key === key && entry.value !== DELETED_1)) {
                return true;
            }
            var frozenIndex = this._getFrozenEntryIndex(key);
            if (frozenIndex >= 0) {
                return true;
            }
            return false;
        };
        WeakMap.prototype.set = function (key, value) {
            if (!key || (typeof key !== 'object' && typeof key !== 'function')) {
                throw new TypeError('Invalid value used as weak map key');
            }
            var entry = key[this._name];
            if (!entry || entry.key !== key) {
                entry = Object.create(null, {
                    key: { value: key }
                });
                if (Object.isFrozen(key)) {
                    this._frozenEntries.push(entry);
                }
                else {
                    Object.defineProperty(key, this._name, {
                        value: entry
                    });
                }
            }
            entry.value = value;
            return this;
        };
        return WeakMap;
    }());
}
exports.default = exports.WeakMap;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = __webpack_require__(0);
var has_1 = __webpack_require__(1);
var util_1 = __webpack_require__(10);
/**
 * The minimum location of high surrogates
 */
exports.HIGH_SURROGATE_MIN = 0xD800;
/**
 * The maximum location of high surrogates
 */
exports.HIGH_SURROGATE_MAX = 0xDBFF;
/**
 * The minimum location of low surrogates
 */
exports.LOW_SURROGATE_MIN = 0xDC00;
/**
 * The maximum location of low surrogates
 */
exports.LOW_SURROGATE_MAX = 0xDFFF;
if (has_1.default('es6-string') && has_1.default('es6-string-raw')) {
    exports.fromCodePoint = global_1.default.String.fromCodePoint;
    exports.raw = global_1.default.String.raw;
    exports.codePointAt = util_1.wrapNative(global_1.default.String.prototype.codePointAt);
    exports.endsWith = util_1.wrapNative(global_1.default.String.prototype.endsWith);
    exports.includes = util_1.wrapNative(global_1.default.String.prototype.includes);
    exports.normalize = util_1.wrapNative(global_1.default.String.prototype.normalize);
    exports.repeat = util_1.wrapNative(global_1.default.String.prototype.repeat);
    exports.startsWith = util_1.wrapNative(global_1.default.String.prototype.startsWith);
}
else {
    /**
     * Validates that text is defined, and normalizes position (based on the given default if the input is NaN).
     * Used by startsWith, includes, and endsWith.
     *
     * @return Normalized position.
     */
    var normalizeSubstringArgs_1 = function (name, text, search, position, isEnd) {
        if (isEnd === void 0) { isEnd = false; }
        if (text == null) {
            throw new TypeError('string.' + name + ' requires a valid string to search against.');
        }
        var length = text.length;
        position = position !== position ? (isEnd ? length : 0) : position;
        return [text, String(search), Math.min(Math.max(position, 0), length)];
    };
    exports.fromCodePoint = function fromCodePoint() {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        // Adapted from https://github.com/mathiasbynens/String.fromCodePoint
        var length = arguments.length;
        if (!length) {
            return '';
        }
        var fromCharCode = String.fromCharCode;
        var MAX_SIZE = 0x4000;
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = Number(arguments[index]);
            // Code points must be finite integers within the valid range
            var isValid = isFinite(codePoint) && Math.floor(codePoint) === codePoint &&
                codePoint >= 0 && codePoint <= 0x10FFFF;
            if (!isValid) {
                throw RangeError('string.fromCodePoint: Invalid code point ' + codePoint);
            }
            if (codePoint <= 0xFFFF) {
                // BMP code point
                codeUnits.push(codePoint);
            }
            else {
                // Astral code point; split in surrogate halves
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                codePoint -= 0x10000;
                var highSurrogate = (codePoint >> 10) + exports.HIGH_SURROGATE_MIN;
                var lowSurrogate = (codePoint % 0x400) + exports.LOW_SURROGATE_MIN;
                codeUnits.push(highSurrogate, lowSurrogate);
            }
            if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                result += fromCharCode.apply(null, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    exports.raw = function raw(callSite) {
        var substitutions = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            substitutions[_i - 1] = arguments[_i];
        }
        var rawStrings = callSite.raw;
        var result = '';
        var numSubstitutions = substitutions.length;
        if (callSite == null || callSite.raw == null) {
            throw new TypeError('string.raw requires a valid callSite object with a raw value');
        }
        for (var i = 0, length_1 = rawStrings.length; i < length_1; i++) {
            result += rawStrings[i] + (i < numSubstitutions && i < length_1 - 1 ? substitutions[i] : '');
        }
        return result;
    };
    exports.codePointAt = function codePointAt(text, position) {
        if (position === void 0) { position = 0; }
        // Adapted from https://github.com/mathiasbynens/String.prototype.codePointAt
        if (text == null) {
            throw new TypeError('string.codePointAt requries a valid string.');
        }
        var length = text.length;
        if (position !== position) {
            position = 0;
        }
        if (position < 0 || position >= length) {
            return undefined;
        }
        // Get the first code unit
        var first = text.charCodeAt(position);
        if (first >= exports.HIGH_SURROGATE_MIN && first <= exports.HIGH_SURROGATE_MAX && length > position + 1) {
            // Start of a surrogate pair (high surrogate and there is a next code unit); check for low surrogate
            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var second = text.charCodeAt(position + 1);
            if (second >= exports.LOW_SURROGATE_MIN && second <= exports.LOW_SURROGATE_MAX) {
                return (first - exports.HIGH_SURROGATE_MIN) * 0x400 + second - exports.LOW_SURROGATE_MIN + 0x10000;
            }
        }
        return first;
    };
    exports.endsWith = function endsWith(text, search, endPosition) {
        if (endPosition == null) {
            endPosition = text.length;
        }
        _a = normalizeSubstringArgs_1('endsWith', text, search, endPosition, true), text = _a[0], search = _a[1], endPosition = _a[2];
        var start = endPosition - search.length;
        if (start < 0) {
            return false;
        }
        return text.slice(start, endPosition) === search;
        var _a;
    };
    exports.includes = function includes(text, search, position) {
        if (position === void 0) { position = 0; }
        _a = normalizeSubstringArgs_1('includes', text, search, position), text = _a[0], search = _a[1], position = _a[2];
        return text.indexOf(search, position) !== -1;
        var _a;
    };
    exports.repeat = function repeat(text, count) {
        if (count === void 0) { count = 0; }
        // Adapted from https://github.com/mathiasbynens/String.prototype.repeat
        if (text == null) {
            throw new TypeError('string.repeat requires a valid string.');
        }
        if (count !== count) {
            count = 0;
        }
        if (count < 0 || count === Infinity) {
            throw new RangeError('string.repeat requires a non-negative finite count.');
        }
        var result = '';
        while (count) {
            if (count % 2) {
                result += text;
            }
            if (count > 1) {
                text += text;
            }
            count >>= 1;
        }
        return result;
    };
    exports.startsWith = function startsWith(text, search, position) {
        if (position === void 0) { position = 0; }
        search = String(search);
        _a = normalizeSubstringArgs_1('startsWith', text, search, position), text = _a[0], search = _a[1], position = _a[2];
        var end = position + search.length;
        if (end > text.length) {
            return false;
        }
        return text.slice(position, end) === search;
        var _a;
    };
}
if (has_1.default('es2017-string')) {
    exports.padEnd = util_1.wrapNative(global_1.default.String.prototype.padEnd);
    exports.padStart = util_1.wrapNative(global_1.default.String.prototype.padStart);
}
else {
    exports.padEnd = function padEnd(text, maxLength, fillString) {
        if (fillString === void 0) { fillString = ' '; }
        if (text === null || text === undefined) {
            throw new TypeError('string.repeat requires a valid string.');
        }
        if (maxLength === Infinity) {
            throw new RangeError('string.padEnd requires a non-negative finite count.');
        }
        if (maxLength === null || maxLength === undefined || maxLength < 0) {
            maxLength = 0;
        }
        var strText = String(text);
        var padding = maxLength - strText.length;
        if (padding > 0) {
            strText += exports.repeat(fillString, Math.floor(padding / fillString.length)) + fillString.slice(0, padding % fillString.length);
        }
        return strText;
    };
    exports.padStart = function padStart(text, maxLength, fillString) {
        if (fillString === void 0) { fillString = ' '; }
        if (text === null || text === undefined) {
            throw new TypeError('string.repeat requires a valid string.');
        }
        if (maxLength === Infinity) {
            throw new RangeError('string.padStart requires a non-negative finite count.');
        }
        if (maxLength === null || maxLength === undefined || maxLength < 0) {
            maxLength = 0;
        }
        var strText = String(text);
        var padding = maxLength - strText.length;
        if (padding > 0) {
            strText = exports.repeat(fillString, Math.floor(padding / fillString.length)) + fillString.slice(0, padding % fillString.length) + strText;
        }
        return strText;
    };
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = __webpack_require__(0);
var has_1 = __webpack_require__(1);
function executeTask(item) {
    if (item && item.isActive && item.callback) {
        item.callback();
    }
}
function getQueueHandle(item, destructor) {
    return {
        destroy: function () {
            this.destroy = function () { };
            item.isActive = false;
            item.callback = null;
            if (destructor) {
                destructor();
            }
        }
    };
}
var checkMicroTaskQueue;
var microTasks;
/**
 * Schedules a callback to the macrotask queue.
 *
 * @param callback the function to be queued and later executed.
 * @returns An object with a `destroy` method that, when called, prevents the registered callback from executing.
 */
exports.queueTask = (function () {
    var destructor;
    var enqueue;
    // Since the IE implementation of `setImmediate` is not flawless, we will test for `postMessage` first.
    if (has_1.default('postmessage')) {
        var queue_1 = [];
        global_1.default.addEventListener('message', function (event) {
            // Confirm that the event was triggered by the current window and by this particular implementation.
            if (event.source === global_1.default && event.data === 'dojo-queue-message') {
                event.stopPropagation();
                if (queue_1.length) {
                    executeTask(queue_1.shift());
                }
            }
        });
        enqueue = function (item) {
            queue_1.push(item);
            global_1.default.postMessage('dojo-queue-message', '*');
        };
    }
    else if (has_1.default('setimmediate')) {
        destructor = global_1.default.clearImmediate;
        enqueue = function (item) {
            return setImmediate(executeTask.bind(null, item));
        };
    }
    else {
        destructor = global_1.default.clearTimeout;
        enqueue = function (item) {
            return setTimeout(executeTask.bind(null, item), 0);
        };
    }
    function queueTask(callback) {
        var item = {
            isActive: true,
            callback: callback
        };
        var id = enqueue(item);
        return getQueueHandle(item, destructor && function () {
            destructor(id);
        });
    }
    ;
    // TODO: Use aspect.before when it is available.
    return has_1.default('microtasks') ? queueTask : function (callback) {
        checkMicroTaskQueue();
        return queueTask(callback);
    };
})();
// When no mechanism for registering microtasks is exposed by the environment, microtasks will
// be queued and then executed in a single macrotask before the other macrotasks are executed.
if (!has_1.default('microtasks')) {
    var isMicroTaskQueued_1 = false;
    microTasks = [];
    checkMicroTaskQueue = function () {
        if (!isMicroTaskQueued_1) {
            isMicroTaskQueued_1 = true;
            exports.queueTask(function () {
                isMicroTaskQueued_1 = false;
                if (microTasks.length) {
                    var item = void 0;
                    while (item = microTasks.shift()) {
                        executeTask(item);
                    }
                }
            });
        }
    };
}
/**
 * Schedules an animation task with `window.requestAnimationFrame` if it exists, or with `queueTask` otherwise.
 *
 * Since requestAnimationFrame's behavior does not match that expected from `queueTask`, it is not used there.
 * However, at times it makes more sense to delegate to requestAnimationFrame; hence the following method.
 *
 * @param callback the function to be queued and later executed.
 * @returns An object with a `destroy` method that, when called, prevents the registered callback from executing.
 */
exports.queueAnimationTask = (function () {
    if (!has_1.default('raf')) {
        return exports.queueTask;
    }
    function queueAnimationTask(callback) {
        var item = {
            isActive: true,
            callback: callback
        };
        var rafId = requestAnimationFrame(executeTask.bind(null, item));
        return getQueueHandle(item, function () {
            cancelAnimationFrame(rafId);
        });
    }
    // TODO: Use aspect.before when it is available.
    return has_1.default('microtasks') ? queueAnimationTask : function (callback) {
        checkMicroTaskQueue();
        return queueAnimationTask(callback);
    };
})();
/**
 * Schedules a callback to the microtask queue.
 *
 * Any callbacks registered with `queueMicroTask` will be executed before the next macrotask. If no native
 * mechanism for scheduling macrotasks is exposed, then any callbacks will be fired before any macrotask
 * registered with `queueTask` or `queueAnimationTask`.
 *
 * @param callback the function to be queued and later executed.
 * @returns An object with a `destroy` method that, when called, prevents the registered callback from executing.
 */
exports.queueMicroTask = (function () {
    var enqueue;
    if (has_1.default('host-node')) {
        enqueue = function (item) {
            global_1.default.process.nextTick(executeTask.bind(null, item));
        };
    }
    else if (has_1.default('es6-promise')) {
        enqueue = function (item) {
            global_1.default.Promise.resolve(item).then(executeTask);
        };
    }
    else if (has_1.default('dom-mutationobserver')) {
        /* tslint:disable-next-line:variable-name */
        var HostMutationObserver = global_1.default.MutationObserver || global_1.default.WebKitMutationObserver;
        var node_1 = document.createElement('div');
        var queue_2 = [];
        var observer = new HostMutationObserver(function () {
            while (queue_2.length > 0) {
                var item = queue_2.shift();
                if (item && item.isActive && item.callback) {
                    item.callback();
                }
            }
        });
        observer.observe(node_1, { attributes: true });
        enqueue = function (item) {
            queue_2.push(item);
            node_1.setAttribute('queueStatus', '1');
        };
    }
    else {
        enqueue = function (item) {
            checkMicroTaskQueue();
            microTasks.push(item);
        };
    }
    return function (callback) {
        var item = {
            isActive: true,
            callback: callback
        };
        enqueue(item);
        return getQueueHandle(item);
    };
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).setImmediate))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(11)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(30);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Promise_1 = __webpack_require__(4);
var quantize_1 = __webpack_require__(35);
var draw_1 = __webpack_require__(33);
var Quantizer = (function () {
    function Quantizer() {
        this.statistics = document.createElement("div");
        this.canvas = document.createElement("canvas");
        this.context = this.canvas.getContext("2d");
        this.statistics.className = "statistics";
    }
    Quantizer.prototype.addTo = function (element) {
        element.appendChild(this.canvas);
        element.appendChild(this.statistics);
    };
    Quantizer.prototype.setProperties = function (props) {
        this.properties = __assign({}, this.properties, props);
        this.render();
    };
    Quantizer.prototype.render = function () {
        var _this = this;
        var _a = this.properties, extent = _a.extent, featureSet = _a.featureSet, scale = _a.scale, removeCollinearVertices = _a.removeCollinearVertices, isClientSide = _a.isClientSide;
        var canvas = this.canvas;
        var context = this.context;
        var size = canvas.clientWidth;
        var promise;
        if (featureSet.transform) {
            if (removeCollinearVertices) {
                promise = quantize_1.cleanup(featureSet);
            }
            else if (featureSet.geometryType === "esriGeometryPolygon") {
                var vertexCount = featureSet.features.reduce(function (count, feature) {
                    return count + feature.geometry.rings.reduce(function (count, ring) {
                        return count + ring.length;
                    }, 0);
                }, 0);
                promise = Promise_1.default.resolve({
                    statistics: {
                        inputFeatureCount: featureSet.features.length,
                        outputFeatureCount: featureSet.features.length,
                        inputVertexCount: vertexCount,
                        outputVertexCount: vertexCount,
                        collinearVertextCount: 0,
                        time: 0
                    },
                    featureSet: featureSet
                });
            }
            else if (featureSet.geometryType === "esriGeometryPoint") {
                promise = Promise_1.default.resolve({
                    statistics: {
                        inputFeatureCount: featureSet.features.length,
                        outputFeatureCount: featureSet.features.length,
                        inputVertexCount: NaN,
                        outputVertexCount: NaN,
                        collinearVertextCount: 0,
                        time: 0
                    },
                    featureSet: featureSet
                });
            }
        }
        else {
            promise = quantize_1.quantize(featureSet, {
                extent: __assign({}, extent),
                tolerance: (extent.xmax - extent.xmin) / size * scale,
                removeCollinearVertices: removeCollinearVertices
            });
        }
        promise.then(function (results) {
            var featureSet = results.featureSet, statistics = results.statistics;
            canvas.width = canvas.clientWidth;
            canvas.height = canvas.clientHeight;
            if (featureSet.geometryType === "esriGeometryPoint") {
                context.fillStyle = "black";
            }
            else {
                context.fillStyle = "rgb(245,245,245)";
            }
            context.lineWidth = 1;
            draw_1.default(context, featureSet, {
                scale: scale,
                fill: true,
                stroke: true
            });
            _this.statistics.innerHTML = "\n      <div><span class=\"title\">\n        <span class=\"value mode\">" + (isClientSide ? "CLIENT" : "SERVER") + "</span> - Quantization: <span class=\"value\">" + scale + "px</span>, remove collinar: <span class=\"value\">" + removeCollinearVertices + "</span></span></div>\n      <hr />\n      <div><span class=\"label\">input features: </span><span class=\"value\">" + statistics.inputFeatureCount + "</span></div>\n      <div><span class=\"label\">output features: </span><span class=\"value\">" + statistics.outputFeatureCount + "</span></div>\n      <div><span class=\"label\">input vertices: </span><span class=\"value\">" + (isNaN(statistics.inputVertexCount) ? "N/A" : statistics.inputVertexCount) + "</span></div>\n      <div><span class=\"label\">output vertices: </span><span class=\"value\">" + (isNaN(statistics.outputVertexCount) ? "N/A" : statistics.outputVertexCount) + "</span></div>\n      <div><span class=\"label\">collinear vertices removed: </span><span class=\"value\">" + (removeCollinearVertices ? statistics.collinearVertextCount : "-") + "</span></div>\n      <div><span class=\"label\">percent removed: </span><span class=\"value\">" + Math.round(100 - statistics.outputVertexCount / statistics.inputVertexCount * 100) + "%</span></div>\n      <div><span class=\"label\">time: </span><span class=\"value\">" + statistics.time + "ms</span></div>\n      ";
        });
    };
    return Quantizer;
}());
function quantizer(node) {
    var q = new Quantizer();
    q.addTo(node);
    return q;
}
exports.quantizer = quantizer;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function draw(context, featureSet, options) {
    switch (featureSet.geometryType) {
        case "esriGeometryPolygon":
            drawPolygons(context, featureSet, options);
            break;
        case "esriGeometryPoint":
            drawPoints(context, featureSet, options);
            break;
        default:
            return;
    }
}
exports.default = draw;
function drawPolygons(context, featureSet, options) {
    var features = featureSet.features;
    var scale = options.scale;
    for (var _i = 0, features_1 = features; _i < features_1.length; _i++) {
        var geometry = features_1[_i].geometry;
        context.beginPath();
        for (var _a = 0, _b = geometry.rings; _a < _b.length; _a++) {
            var ring = _b[_a];
            var _c = ring[0], x = _c[0], y = _c[1];
            x *= scale;
            y *= scale;
            context.moveTo(x, y);
            for (var i = 1; i < ring.length; i++) {
                x += ring[i][0] * scale;
                y += ring[i][1] * scale;
                context.lineTo(x, y);
            }
        }
        if (options.stroke) {
            context.stroke();
        }
        if (options.fill) {
            context.fill();
        }
    }
}
function drawPoints(context, featureSet, options) {
    var features = featureSet.features;
    var scale = options.scale;
    for (var _i = 0, features_2 = features; _i < features_2.length; _i++) {
        var _a = features_2[_i].geometry, x = _a.x, y = _a.y;
        context.fillRect(x * scale, y * scale, 2, 2);
    }
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var xhr_1 = __webpack_require__(22);
function getUrlParams(search) {
    var hashes = search.slice(search.indexOf('?') + 1).split('&');
    var params = {};
    hashes.map(function (hash) {
        var _a = hash.split('='), key = _a[0], val = _a[1];
        params[key] = decodeURIComponent(val);
    });
    return params;
}
var _a = getUrlParams(window.location.search).serviceUrl, serviceUrl = _a === void 0 ? "https://services.arcgis.com/BG6nSlhZSAWtExvp/arcgis/rest/services/EnergyUse_countries/FeatureServer/0" : _a;
function query(scale) {
    var extent = {
        xmin: -20037508.342787,
        ymin: -20037508.342780,
        xmax: 20037508.342780,
        ymax: 20037508.342787,
        spatialReference: {
            latestWkid: 3857,
            wkid: 102100
        }
    };
    var quantizationParameters = scale == null ? {} : {
        quantizationParameters: JSON.stringify({
            mode: "view",
            originPosition: "upperLeft",
            extent: extent,
            tolerance: (extent.xmax - extent.xmin) / 512 * scale
        })
    };
    return xhr_1.default(serviceUrl + "/query", {
        query: __assign({ f: "json", where: "1=1" }, quantizationParameters, { outSR: "102100", resultType: "tile", maxRecordCountFactor: "5" }),
        includeRequestedWithHeader: false
    })
        .then(function (response) { return response.json(); })
        .then(function (featureSet) {
        if (quantizationParameters.quantizationParameters && !featureSet.transform) {
            throw new Error("invalid server-side quantization - missing tranform in featureset");
        }
        return {
            featureSet: featureSet,
            extent: {
                xmin: -20037508.342787,
                ymin: -20037508.342780,
                xmax: 20037508.342780,
                ymax: 20037508.342787
            }
        };
    });
}
exports.query = query;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Task_1 = __webpack_require__(7);
function quantize(featureSet, quantizationParameters) {
    return new Task_1.default(function (resolve) {
        var statistics = {
            inputFeatureCount: featureSet.features.length,
            outputFeatureCount: 0,
            inputVertexCount: 0,
            outputVertexCount: 0,
            collinearVertextCount: 0,
            time: 0
        };
        var now = Date.now();
        var results = {
            featureSet: null,
            statistics: statistics
        };
        switch (featureSet.geometryType) {
            case "esriGeometryPoint":
                results.featureSet = quantizePointFeatureSet(featureSet, quantizationParameters, statistics);
                break;
            case "esriGeometryPolygon":
                results.featureSet = quantizePolygonFeatureSet(featureSet, quantizationParameters, statistics);
                break;
        }
        statistics.outputFeatureCount = results.featureSet.features.length;
        statistics.time = Date.now() - now;
        resolve(results);
    });
}
exports.quantize = quantize;
function quantizePointFeatureSet(featureSet, quantizationParameters, statistics) {
    var output = {
        geometryType: "esriGeometryPoint",
        features: [],
        transform: {
            originPosition: "upperLeft",
            scale: [quantizationParameters.tolerance, quantizationParameters.tolerance],
            translate: [
                quantizationParameters.extent.xmin,
                quantizationParameters.extent.ymax
            ]
        }
    };
    for (var _i = 0, _a = featureSet.features; _i < _a.length; _i++) {
        var feature = _a[_i];
        var quantized = quantizePoint(feature.geometry, quantizationParameters, statistics);
        if (quantized) {
            output.features.push({
                geometry: quantized
            });
        }
    }
    return output;
}
function quantizePolygonFeatureSet(featureSet, quantizationParameters, statistics) {
    var output = {
        geometryType: "esriGeometryPolygon",
        features: [],
        transform: {
            originPosition: "upperLeft",
            scale: [quantizationParameters.tolerance, quantizationParameters.tolerance],
            translate: [
                quantizationParameters.extent.xmin,
                quantizationParameters.extent.ymax
            ]
        }
    };
    for (var _i = 0, _a = featureSet.features; _i < _a.length; _i++) {
        var feature = _a[_i];
        var quantized = quantizePolygon(feature.geometry, quantizationParameters, statistics);
        if (quantized) {
            output.features.push({
                geometry: quantized
            });
        }
    }
    return output;
}
function quantizePoint(geometry, quantizationParameters, statistics) {
    var tx = quantizationParameters.extent.xmin;
    var ty = quantizationParameters.extent.ymax;
    var s = quantizationParameters.tolerance;
    return {
        x: Math.round((geometry.x - tx) / s),
        y: Math.round((ty - geometry.y) / s)
    };
}
function quantizePolygon(geometry, quantizationParameters, statistics) {
    var rings = [];
    var tx = quantizationParameters.extent.xmin;
    var ty = quantizationParameters.extent.ymax;
    var s = quantizationParameters.tolerance;
    for (var _i = 0, _a = geometry.rings; _i < _a.length; _i++) {
        var ring = _a[_i];
        var newRing = [];
        statistics.inputVertexCount += ring.length;
        newRing[0] = [
            Math.round((ring[0][0] - tx) / s),
            Math.round((ty - ring[0][1]) / s)
        ];
        var iNewRing = 1;
        var _b = newRing[0], prevX = _b[0], prevY = _b[1];
        var delta = null;
        for (var i = 1, n = ring.length; i < n; i++) {
            var x = Math.round((ring[i][0] - tx) / s);
            var y = Math.round((ty - ring[i][1]) / s);
            if (x !== prevX || y !== prevY) {
                var dx = x - prevX;
                var dy = y - prevY;
                if (quantizationParameters.removeCollinearVertices && delta && ((delta[0] === 0 && dx === 0) || (delta[1] === 0 && dy === 0))) {
                    delta[0] += dx;
                    delta[1] += dy;
                    statistics.collinearVertextCount++;
                }
                else {
                    delta = [dx, dy];
                    newRing[iNewRing] = delta;
                    iNewRing++;
                }
                prevX = x;
                prevY = y;
            }
        }
        if (newRing.length >= 3) {
            rings.push(newRing);
            statistics.outputVertexCount += newRing.length;
        }
    }
    if (rings.length > 0) {
        return {
            rings: rings
        };
    }
    else {
        return null;
    }
}
function cleanup(featureSet) {
    return new Task_1.default(function (resolve) {
        var statistics = {
            inputFeatureCount: featureSet.features.length,
            outputFeatureCount: 0,
            inputVertexCount: 0,
            outputVertexCount: 0,
            collinearVertextCount: 0,
            time: 0
        };
        var now = Date.now();
        var results = {
            featureSet: null,
            statistics: statistics
        };
        switch (featureSet.geometryType) {
            case "esriGeometryPolygon":
                results.featureSet = cleanupPolygonFeatureSet(featureSet, statistics);
                break;
            default:
                results.featureSet = featureSet;
                break;
        }
        statistics.outputFeatureCount = results.featureSet.features.length;
        statistics.time = Date.now() - now;
        resolve(results);
    });
}
exports.cleanup = cleanup;
function cleanupPolygonFeatureSet(featureSet, statistics) {
    var output = {
        geometryType: "esriGeometryPolygon",
        features: [],
        transform: __assign({}, featureSet.transform)
    };
    for (var _i = 0, _a = featureSet.features; _i < _a.length; _i++) {
        var feature = _a[_i];
        var clean = cleanupPolygon(feature.geometry, statistics);
        if (clean) {
            output.features.push({
                geometry: clean
            });
        }
    }
    return output;
}
function cleanupPolygon(geometry, statistics) {
    var rings = [];
    for (var _i = 0, _a = geometry.rings; _i < _a.length; _i++) {
        var ring = _a[_i];
        var newRing = [];
        statistics.inputVertexCount += ring.length;
        newRing[0] = [
            ring[0][0],
            ring[0][1]
        ];
        var iNewRing = 1;
        var delta = null;
        for (var i = 1, n = ring.length; i < n; i++) {
            var dx = ring[i][0];
            var dy = ring[i][1];
            if (delta && ((delta[0] === 0 && dx === 0) || (delta[1] === 0 && dy === 0))) {
                delta[0] += dx;
                delta[1] += dy;
                statistics.collinearVertextCount++;
            }
            else {
                delta = [dx, dy];
                newRing[iNewRing] = delta;
                iNewRing++;
            }
        }
        if (newRing.length >= 3) {
            rings.push(newRing);
            statistics.outputVertexCount += newRing.length;
        }
    }
    if (rings.length > 0) {
        return {
            rings: rings
        };
    }
    else {
        return null;
    }
}


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(12);
module.exports = __webpack_require__(13);


/***/ })
/******/ ]);
})
// When using require, call the module automatically
typeof define === 'function' && define.amd && require(['src/main']);
;


// WEBPACK FOOTER //
// src/main.js